// PropertyGuysDashboard.jsx
import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Tooltip,
  Avatar,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
   ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import CoverageMap from './CoverageMap';

import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';


import {
  collection,
  collectionGroup,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  doc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
} from 'firebase/firestore';
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from "react-simple-maps";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SmsIcon from '@mui/icons-material/Sms';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
// Service icons



import Badge from '@mui/material/Badge';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';



import PlumbingIcon from '@mui/icons-material/Plumbing';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BoltIcon from '@mui/icons-material/Bolt';
import RoofingIcon from '@mui/icons-material/Roofing';
import GrassIcon from '@mui/icons-material/Grass';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BuildIcon from '@mui/icons-material/Build';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';

import PlayArrowIcon from '@mui/icons-material/PlayArrow'; // ⬅️ ADD THIS
import RefreshIcon from '@mui/icons-material/Refresh';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { db } from './firebase'; // adjust path if needed
import ScrapeHealthModal from './ScrapeHealthModal';
import logo2 from './leadfeed.png';
import logo3 from './ypg.png';

// GHL Numbers (normalized exactly like normalizePhone in the webhook)
const VIRGINIA_NUMBER = '+14433890281';
const MEMPHIS_NUMBER  = '+19017636278';
const getMaxDMsForAccount = (account) => {
  const label = String(account || '').trim();

  const nashvilleMatch = label.match(/^Nashville\s+(\d+)/i);
  if (nashvilleMatch) {
    const num = parseInt(nashvilleMatch[1], 10);

    // Nashville 1-5 = max 2 DMs/day
    if (num >= 1 && num <= 5) return 2;
  }

  const memphisMatch = label.match(/^Memphis\s+(\d+)/i);
  if (memphisMatch) {
    const num = parseInt(memphisMatch[1], 10);

    // Memphis 10 = max 2 DMs/day
    if (num === 10) return 2;

    // Existing Memphis behavior
    return 2;
  }

  const houstonMatch = label.match(/^Houston\s+(\d+)/i);
  if (houstonMatch) {
    const num = parseInt(houstonMatch[1], 10);

    if (num >= 1 && num <= 7) return 3;
    if (num >= 8 && num <= 11) return 2;
  }

  return 2;
};

const normalizeMarketLabel = (value) => {
  const norm = String(value || '').trim().toLowerCase();

  if (norm === 'northern virginia' || norm.startsWith('northern virginia ')) {
    return 'Northern Virginia';
  }

  if (norm === 'nova') {
    return 'Northern Virginia';
  }

  if (norm === 'memphis' || norm === 'midsouth') {
    return 'Memphis';
  }

  // Fallback: keep whatever it was, or default to Memphis
  const trimmed = (value || '').toString().trim();
  return trimmed || 'Memphis';
};
const SERVICE_LABELS = [
  'Plumbing',
  'HVAC',
  'Electric',
  'Roofing/Gutters',
  'Tree',
  'Lawn/Landscape',
  'Fencing/Railing',
  'Painting/Drywall',
  'Concrete/Masonry',
  'Appliance',
  'Pest',
  'Junk/Moving',
  'Pressure Cleaning',

  'Windows/Doors',
  'Flooring',
  'Handyman/General',
    'Auto',             // ← NEW
  'Restoration',        // ← Raleigh (Michael & Son): water/fire/mold damage
  'Demolition',         // ← South FL (West Palm): tear-down / demo jobs

  'Other/Unclear',
];
const MEMPHIS_DM_ACCOUNTS = [
  // Memphis
  'Memphis 1',
  'Memphis 2',
  'Memphis 3',
  'Memphis 4',
  'Memphis 5',
  'Memphis 6',
  'Memphis 7',
  'Memphis 8',
  'Memphis 9',
  'Memphis 10',

  // Northern Virginia
  'NOVA 1',
  'NOVA 2',
  'NOVA 3',
  'NOVA 4',
  'NOVA 5',

  // Dallas
  'Dallas 1',
  'Dallas 2',
  'Dallas 3',
  'Dallas 4',
  'Dallas 5',
  'Dallas 6',
  'Dallas 7',
  'Dallas 8',
  'Dallas 9',
  'Dallas 10',
  'Dallas 11',
  'Dallas 12',
  'Dallas 13',
  'Dallas 14',
  'Dallas 15',
  'Dallas 16',
  'Dallas 17',
  'Dallas 18',
  'Dallas 19',
  'Dallas 20',
  'Dallas 21',
  'Dallas 22',
  'Dallas 23',

  // South Florida accounts were removed from this picker — the market is paused,
  // so there is nothing to DM from. Existing SouthFL leads still display and the
  // market normalization elsewhere in this file is untouched; only the ability to
  // mark NEW leads as DMed from a SouthFL account is gone.

  // Raleigh — Michael & Son
  'Raleigh 1',
  'Raleigh 2',
  'Raleigh 3',
  'Raleigh 4',
  'Raleigh 5',

  // Baltimore — Michael & Son
  'Baltimore 1',
  'Baltimore 2',
  'Baltimore 3',
  'Baltimore 4',
  'Baltimore 5',
  'Baltimore 6',
  'Baltimore 7',

  // Fredericksburg — Michael & Son
  'Fredericksburg 1',
  'Fredericksburg 2',
  'Fredericksburg 3',
  'Fredericksburg 4',
  'Fredericksburg 5',
  'Fredericksburg 6',
  'Fredericksburg 7',

  // Richmond — Michael & Son
  'Richmond 1',
  'Richmond 2',
  'Richmond 3',
  'Richmond 4',
  'Richmond 5',
  'Richmond 6',
  'Richmond 7',
  'Richmond 8',
  'Richmond 9',

  // Norfolk / Hampton Roads — Michael & Son
  'Norfolk 1',
  'Norfolk 2',
  'Norfolk 3',
  'Norfolk 4',
  'Norfolk 5',
  'Norfolk 6',
  'Norfolk 7',

  // Greensboro — Michael & Son (3 lanes, no Restoration)
  'Greensboro 1',
  'Greensboro 2',
  'Greensboro 3',
  'Greensboro 4',
  'Greensboro 5',
  'Greensboro 6',

  // Wilmington NC — Michael & Son (3 lanes, no Restoration)
  'Wilmington NC 1',
  'Wilmington NC 2',
  'Wilmington NC 3',
  'Wilmington NC 4',
  'Wilmington NC 5',
  'Wilmington NC 6',

  // Myrtle Beach — Michael & Son (3 lanes, no Restoration)
  'Myrtle Beach 1',
  'Myrtle Beach 2',

  // Charlotte — Michael & Son
  'Charlotte 1',
  'Charlotte 2',
  'Charlotte 3',
  'Charlotte 4',
  'Charlotte 5',
  'Charlotte 6',
  'Charlotte 7',
  'Charlotte 8',
  'Charlotte 9',

  // Charlottesville — Michael & Son
  'Charlottesville 1',
  'Charlottesville 2',
  'Charlottesville 3',
  'Charlottesville 4',
  'Charlottesville 5',
  'Charlottesville 6',
  'Charlottesville 7',
  'Charlottesville 8',
  'Charlottesville 9',
  'Charlottesville 10',
  'Charlottesville 11',
  'Charlottesville 12',
  'Charlottesville 13',
  'Charlottesville 14',

  // DMV VA — Michael & Son (6 lanes)
  'DMV VA 1',
  'DMV VA 2',
  'DMV VA 3',
  'DMV VA 4',
  'DMV VA 5',
  'DMV VA 6',

  // DMV MD/DC — Michael & Son (6 lanes)
  'DMV MD/DC 1',
  'DMV MD/DC 2',
  'DMV MD/DC 3',
  'DMV MD/DC 4',
  'DMV MD/DC 5',
  'DMV MD/DC 6',
  'DMV MD/DC 7',
  'DMV MD/DC 8',
  'DMV MD/DC 9',
  'DMV MD/DC 10',
  'DMV MD/DC 11',

  // Los Angeles — Rooter Hero
  'LA 1',
  'LA 2',
  'LA 3',
  'LA 4',
  'LA 5',
  'LA 6',
];
const SERVICE_ICONS = {
  Plumbing: PlumbingIcon,
  HVAC: AcUnitIcon,
  Electric: BoltIcon,
  'Roofing/Gutters': RoofingIcon,
  'Lawn/Landscape': GrassIcon,
  'Junk/Moving': LocalShippingIcon,
  'Pressure Cleaning': BuildIcon,

  'Handyman/General': HomeRepairServiceIcon,
  Flooring: BuildIcon,
  'Windows/Doors': HomeRepairServiceIcon,
  'Painting/Drywall': BuildIcon,
  'Concrete/Masonry': BuildIcon,
  Appliance: BuildIcon,
  Pest: BuildIcon,
  Tree: BuildIcon,
    Auto: DirectionsCarIcon,      // ← NEW

  'Fencing/Railing': BuildIcon,
  'General Contractor': HomeRepairServiceIcon,
  Restoration: HomeRepairServiceIcon,
  Demolition: BuildIcon,
  'Other/Unclear': DeviceUnknownIcon,
};
const MARKET_ROOT_COLLECTION = {
  Memphis: 'newscrapes',
  'Northern Virginia': 'newscrapesVA',
  Houston: 'newscrapesHouston',
  Nashville: 'newscrapesNashville',
  LongIsland: 'newscrapesLongIsland',
  Tampa: 'newscrapesTampa',
    SouthFL: 'newscrapesSouthFL',
  FtMyers: 'newscrapesFtMyers',
  Miami: 'newscrapesMiami',
  Dallas: 'newscrapesDallas',
  Atlanta: 'newscrapesAtlanta',
  Denver: 'newscrapesDenver',
  Orlando: 'newscrapesOrlando',
  Panhandle: 'newscrapesPanhandle',
  Connecticut: 'newscrapesConnecticut',
  Raleigh: 'newscrapesRaleigh',
  Baltimore: 'newscrapesBaltimore',
  LosAngeles: 'newscrapesLosAngeles',
  Fredericksburg: 'newscrapesFredericksburg',
  Richmond: 'newscrapesRichmond',
  Norfolk: 'newscrapesNorfolk',
  Greensboro: 'newscrapesGreensboro',
  WilmingtonNC: 'newscrapesWilmingtonNC',
  MyrtleBeach: 'newscrapesMyrtleBeach',
  Charlotte: 'newscrapesCharlotte',
  Charlottesville: 'newscrapesCharlottesville',
  DmvVa: 'newscrapesDmvVa',
  DmvMdDc: 'newscrapesDmvMdDc',
};

function normalizeDashboardMarket(input = '') {
  const m = String(input || '').trim().toLowerCase();

  if (m.startsWith('memphis')) return 'Memphis';
  if (m.startsWith('nova') || m.startsWith('northern virginia')) return 'Northern Virginia';
  if (m.startsWith('houston')) return 'Houston';
  if (m.startsWith('nashville')) return 'Nashville';
  if (m.startsWith('longisland') || m.startsWith('long island')) return 'LongIsland';
  if (m.startsWith('tampa')) return 'Tampa';
  if (m.startsWith('ftmyers') || m.startsWith('ft myers') || m.startsWith('fort myers')) return 'FtMyers';
  if (m.startsWith('miami')) return 'Miami';
    if (m.startsWith('southfl') || m.startsWith('south fl') || m.startsWith('south florida')) return 'SouthFL';

  if (m.startsWith('dallas')) return 'Dallas';
  if (m.startsWith('atlanta')) return 'Atlanta';
  if (m.startsWith('denver')) return 'Denver';
  if (m.startsWith('panhandle')) return 'Panhandle';
if (m.startsWith('orlando')) return 'Orlando';
  if (m.startsWith('connecticut')) return 'Connecticut';
  if (m.startsWith('raleigh')) return 'Raleigh';
  if (m.startsWith('baltimore')) return 'Baltimore';
  if (m.startsWith('fredericksburg')) return 'Fredericksburg';
  if (m.startsWith('richmond')) return 'Richmond';
  if (m.startsWith('norfolk')) return 'Norfolk';
  if (m.startsWith('greensboro')) return 'Greensboro';
  if (m.startsWith('wilmington')) return 'WilmingtonNC';
  if (m.startsWith('myrtle')) return 'MyrtleBeach';
  // the map pin's key is 'DmvVa' -> 'dmvva', so match that form too
  if (m.startsWith('dmv md') || m.startsWith('dmv-md') || m.startsWith('dmvmddc')) return 'DmvMdDc';
  if (m.startsWith('dmv va') || m.startsWith('dmv-va') || m.startsWith('dmvva')) return 'DmvVa';
  if (m.startsWith('charlottesville')) return 'Charlottesville';
  if (m.startsWith('charlotte') && !m.startsWith('charlottesville')) return 'Charlotte';
  // "la" is 2 chars — match exactly, never as a prefix (would catch Lakeland etc.)
  if (m === 'la' || /^la\s*\d+$/.test(m) || m.startsWith('los angeles') || m.startsWith('losangeles')) return 'LosAngeles';
  return 'Memphis';
}

// ─────────────────────────────────────────────────────────────────────────────
// Northern Virginia is worked by TWO clients at once: SwiftPro holds HVAC +
// Plumbing there, Michael & Son gets everything else in the same footprint.
// Leads written from 2026-09-08 carry a stored `client`; older ones are
// classified here so history reads the same. Mirrors clientForLead() in
// scraper-functions/index.js.
// ─────────────────────────────────────────────────────────────────────────────
const SWIFTPRO_LANES = new Set(['HVAC', 'Plumbing']);
const CLIENT_TAG = {
  SwiftPro:      { label: 'SWIFTPRO', fg: '#67e8f9', bg: 'rgba(34,211,238,0.16)', bd: 'rgba(34,211,238,0.6)' },
  MichaelAndSon: { label: 'M & SON',  fg: '#ddd6fe', bg: 'rgba(167,139,250,0.16)', bd: 'rgba(167,139,250,0.6)' },
};

/** Only shared markets get a tag — elsewhere it would be noise on every row. */
function clientTagFor(lead, marketStr = '') {
  const isNova = String(marketStr).toLowerCase().includes('northern virginia')
    || String(marketStr).toLowerCase() === 'nova';
  if (!isNova) return null;
  const stored = lead && lead.client;
  if (stored) return CLIENT_TAG[stored] || null;
  const svc = (lead && (lead.serviceType || lead.classification)) || '';
  return SWIFTPRO_LANES.has(svc) ? CLIENT_TAG.SwiftPro : CLIENT_TAG.MichaelAndSon;
}

function rootCollectionFromMarket(selectedMarket = '') {
  const canonical = normalizeDashboardMarket(selectedMarket);
  return MARKET_ROOT_COLLECTION[canonical] || 'newscrapes';
}
// Still used for subtle highlighting if you want later
const IMPORTANT_SERVICES = [
  'HVAC',
  'Electric',
  'Plumbing',
  'Roofing/Gutters',
  'Junk/Moving',
  'Lawn/Landscape',
  'Handyman/General',
    'Auto', // ← NEW

];

function normalizeSvc(raw) {
  const s = (raw || '').trim();
  if (!s) return 'Other/Unclear';
  if (SERVICE_LABELS.includes(s)) return s;
  return 'Other/Unclear';
}

function tsToDate(ts) {
  if (!ts) return null;
  if (ts.toDate) return ts.toDate();
  if (typeof ts === 'number') return new Date(ts);
  return null;
}

function formatLeadElapsed(totalSeconds) {
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return null;

  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

function getLeadCapturedAtDate(lead) {
  return tsToDate(lead?.capturedAt) || tsToDate(lead?.createdAt) || null;
}



function getLeadTimerMeta(lead, nowMs = Date.now()) {
  const capturedAt = getLeadCapturedAtDate(lead);

  const savedSeconds = Number(lead?.captureTimerStoppedSeconds);

  const stopAt =
    tsToDate(lead?.captureTimerStoppedAt) ||
    tsToDate(lead?.manualDmedAt) ||
    tsToDate(lead?.badLeadAt) ||
    null;

  let elapsedSeconds = null;
  let isStopped = false;

  if (Number.isFinite(savedSeconds)) {
    elapsedSeconds = Math.max(0, Math.floor(savedSeconds));
    isStopped = true;
  } else if (capturedAt && stopAt) {
    elapsedSeconds = Math.max(
      0,
      Math.floor((stopAt.getTime() - capturedAt.getTime()) / 1000)
    );
    isStopped = true;
  } else if (capturedAt) {
    elapsedSeconds = Math.max(
      0,
      Math.floor((nowMs - capturedAt.getTime()) / 1000)
    );
    isStopped = !!lead?.manualDmed || !!lead?.isBadLead;
  }

  return {
    capturedAt,
    elapsedSeconds,
    label:
      lead?.captureTimerStoppedLabel || formatLeadElapsed(elapsedSeconds),
    isStopped,
  };
}
const GEO_URL = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const MARKET_POINTS = [
  { key: "Memphis", label: "Memphis", coords: [-90.049, 35.149] },
  { key: "Northern Virginia", label: "NOVA", coords: [-77.45, 38.90] },
  { key: "Houston", label: "Houston", coords: [-95.3698, 29.7604] },
  { key: "Dallas", label: "Dallas", coords: [-96.797, 32.7767] },
  { key: "Nashville", label: "Nashville", coords: [-86.7816, 36.1627] },
  { key: "Orlando", label: "Orlando", coords: [-81.3792, 28.5383] },
  { key: "Tampa", label: "Tampa", coords: [-82.4572, 27.9506] },
  { key: "Miami", label: "Miami", coords: [-80.1918, 25.7617] },
  { key: "FtMyers", label: "Ft Myers", coords: [-81.8723, 26.6406] },
  { key: "SouthFL", label: "South FL", coords: [-80.2039, 26.1224] },
  // Existing
  { key: "Atlanta", label: "Atlanta", coords: [-84.3880, 33.7490] },
  { key: "Denver", label: "Denver", coords: [-104.9903, 39.7392] },
  { key: "Panhandle", label: "Panhandle", coords: [-86.60, 30.42] }, // Destin-ish anchor

  // ✅ NEW — Long Island (11706 - Bay Shore)
  { key: "LongIsland", label: "Long Island", coords: [-73.2446, 40.7251] },

  // Iluki Construction — Connecticut (Hartford anchor)
  { key: "Connecticut", label: "Connecticut", coords: [-72.6851, 41.7637] },

  // Michael & Son — Raleigh, NC
  { key: "Raleigh", label: "Raleigh", coords: [-78.6382, 35.7796] },

  // Michael & Son — Baltimore, MD
  { key: "Baltimore", label: "Baltimore", coords: [-76.6122, 39.2904] },
  // Michael & Son — Fredericksburg, VA
  { key: "Fredericksburg", label: "Fredericksburg", coords: [-77.4605, 38.3032] },

  // Michael & Son — Richmond, VA
  { key: "Richmond", label: "Richmond", coords: [-77.4360, 37.5407] },

  // Michael & Son — Norfolk / Hampton Roads, VA
  { key: "Norfolk", label: "Norfolk", coords: [-76.2859, 36.8508] },

  // Michael & Son — Greensboro, NC
  { key: "Greensboro", label: "Greensboro", coords: [-79.7920, 36.0726], side: "left" },

  // Michael & Son — Wilmington, NC
  { key: "WilmingtonNC", label: "Wilmington NC", coords: [-77.9447, 34.2257] },

  // Michael & Son — Myrtle Beach, SC
  { key: "MyrtleBeach", label: "Myrtle Beach", coords: [-78.8867, 33.6891] },

  // Michael & Son — Charlotte, NC
  { key: "Charlotte", label: "Charlotte", coords: [-80.8431, 35.2271] },

  // Michael & Son — Charlottesville, VA
  { key: "Charlottesville", label: "Charlottesville", coords: [-78.4767, 38.0293] },

  // Michael & Son — DMV Virginia (outer ring, beyond the NOVA circles)
  { key: "DmvVa", label: "DMV VA (outer)", coords: [-78.1035, 39.0299], side: "left" },

  // Michael & Son — DMV Maryland + DC (outer ring, east and south of NOVA)
  { key: "DmvMdDc", label: "DMV MD/DC", coords: [-76.9000, 38.5500] },

  // Rooter Hero Plumbing & Air — Los Angeles, CA
  { key: "LosAngeles", label: "Los Angeles", coords: [-118.2437, 34.0522] }
];

// The East-Coast markets (Michael & Son's whole footprint plus Baltimore and
// Raleigh) sit on top of each other at national scale — their pins overlap and
// most can't be clicked. This zooms into the Mid-Atlantic so every one is
// separated and hittable.
const MAP_REGIONS = {
  usa:  { label: 'USA',        zoom: 1,   center: [-97, 38] },
  east: { label: 'East Coast', zoom: 3.4, center: [-78.4, 37.6] },
};

function MarketMap({ value, onChange, height = 170, compact = false }) {
  const [region, setRegion] = React.useState('usa');
  const view = MAP_REGIONS[region];
  // ZoomableGroup scales its children, so counter-scale the pins and labels or
  // they balloon to 3.4x and overlap worse than before.
  const k = 1 / view.zoom;
  return (
    <Box
      sx={{
        width: compact ? 520 : "100%",
        maxWidth: compact ? 520 : 980,
        mx: "auto",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        background:
          "radial-gradient(800px 240px at 20% 10%, rgba(34,211,238,0.18), transparent 60%), radial-gradient(900px 260px at 80% 0%, rgba(99,102,241,0.16), transparent 55%), linear-gradient(180deg, #0b1220 0%, #050912 100%)",
        boxShadow: "0 18px 70px rgba(0,0,0,0.28)",
        border: "1px solid rgba(148,163,184,0.18)",
      }}
    >
      {/* subtle grid */}
      <Box
        sx={{
          pointerEvents: "none",
          position: "absolute",
          inset: 0,
          opacity: 0.25,
          backgroundImage:
            "linear-gradient(rgba(148,163,184,0.10) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.10) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
          maskImage: "radial-gradient(circle at 50% 30%, black 40%, transparent 70%)",
        }}
      />

      <Box
        sx={{
          position: 'absolute', top: 10, right: 12, zIndex: 3,
          display: 'flex', gap: 0.5, p: 0.4, borderRadius: 2,
          bgcolor: 'rgba(2,6,23,0.75)', border: '1px solid rgba(148,163,184,0.25)',
          backdropFilter: 'blur(6px)',
        }}
      >
        {Object.entries(MAP_REGIONS).map(([k2, r]) => (
          <Box
            key={k2}
            onClick={() => setRegion(k2)}
            sx={{
              cursor: 'pointer', px: 1.2, py: 0.35, borderRadius: 1.5,
              fontSize: 11, fontWeight: 800, letterSpacing: '.04em',
              color: region === k2 ? '#04121a' : '#94a3b8',
              bgcolor: region === k2 ? '#22d3ee' : 'transparent',
              '&:hover': { color: region === k2 ? '#04121a' : '#e2e8f0' },
            }}
          >{r.label}</Box>
        ))}
      </Box>

      <Box sx={{ p: 1.5 }}>
        <ComposableMap
  projection="geoAlbersUsa"
  projectionConfig={{ scale: compact ? 1200 : 1250 }}
  style={{ width: "100%", height }}
>
          <ZoomableGroup zoom={view.zoom} center={view.center} minZoom={1} maxZoom={8}>
          <Geographies geography={GEO_URL}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: "rgba(148,163,184,0.10)",
                      stroke: "rgba(148,163,184,0.22)",
                      strokeWidth: 0.6,
                      outline: "none",
                    },
                    hover: {
                      fill: "rgba(148,163,184,0.14)",
                      stroke: "rgba(148,163,184,0.28)",
                      outline: "none",
                    },
                    pressed: {
                      fill: "rgba(148,163,184,0.14)",
                      outline: "none",
                    },
                  }}
                />
              ))
            }
          </Geographies>

          {MARKET_POINTS.map((m) => {
            const selected = value === m.key;
            return (
              <Marker key={m.key} coordinates={m.coords}>
                {/* click target */}
                <g
                  onClick={() => onChange(m.key)}
                  style={{ cursor: "pointer" }}
                >
                  {/* glow */}
                  <g transform={`scale(${k})`}>
                  <circle
                    r={selected ? 7 : 6}
                    fill={selected ? "rgba(34,211,238,0.25)" : "rgba(99,102,241,0.22)"}
                  />
                  {/* core */}
                  <circle
                    r={selected ? 3.3 : 3}
                    fill={selected ? "#22d3ee" : "#a78bfa"}
                  />

                  {/* label pill — left-side for markets that would otherwise
                      be buried by a neighbour's pill (they are opaque and draw
                      in array order) */}
                  <g transform={
                    m.side === 'left'
                      ? `translate(${-(m.label.length * 7.2 + 18) - 10},-12)`
                      : 'translate(10,-12)'
                  }>
                    <rect
                      x="0"
                      y="0"
                      rx="10"
                      ry="10"
                      width={m.label.length * 7.2 + 18}
                      height="20"
                      fill={selected ? "rgba(15,23,42,0.92)" : "rgba(15,23,42,0.78)"}
                      stroke={selected ? "rgba(34,211,238,0.8)" : "rgba(148,163,184,0.25)"}
                      strokeWidth="1"
                    />
                    <text
                      x="9"
                      y="14"
                      style={{
                        fontSize: 11,
                        fontWeight: 800,
                        fill: selected ? "#22d3ee" : "#e2e8f0",
                        fontFamily: "ui-sans-serif, system-ui",
                      }}
                    >
                      {m.label}
                    </text>
                  </g>
                  </g>
                </g>
              </Marker>
            );
          })}
          </ZoomableGroup>
        </ComposableMap>
      </Box>
    </Box>
  );
}

function canonicalMarketFrom(marketRaw = '') {
  const m = marketRaw.toLowerCase();

  if (m.includes('tampa')) return 'Tampa';
  if (m.includes('long island') || m.includes('longisland')) return 'Long Island';
  if (m.includes('houston')) return 'Houston';
  if (m.includes('nashville')) return 'Nashville';   // ✅ ADD THIS
  if (m.includes('virginia') || m.includes('nova')) return 'Northern Virginia';
  if (m.includes('miami')) return 'Miami';
    if (m.includes('southfl') || m.includes('south fl') || m.includes('south florida')) return 'SouthFL';
  if (m.includes('atlanta')) return 'Atlanta';
  if (m.includes('denver')) return 'Denver';
  if (m.includes('panhandle') || m.includes('florida panhandle') || m.includes('fl panhandle')) return 'Panhandle';
  if (m.includes('orlando')) return 'Orlando';
if (m.includes('ftmyers') || m.includes('ft myers') || m.includes('fort myers')) {
  return 'FtMyers';
}
  return 'Memphis';
}
 function extractLeadValueSource(lead, dm) {
  const src = lead || {};
  const dmSrc = dm || {};

  const lv = src.leadValue || {};
  const dmLv = dmSrc.leadValue || {};

  // Prefer explicit estimatedValue, then baselineAvg
  const raw =
    typeof src.estimatedValue === 'number'
      ? src.estimatedValue
      : typeof dmSrc.estimatedValue === 'number'
      ? dmSrc.estimatedValue
      : typeof lv.estimatedValue === 'number'
      ? lv.estimatedValue
      : typeof dmLv.estimatedValue === 'number'
      ? dmLv.estimatedValue
      : typeof src.baselineAvg === 'number'
      ? src.baselineAvg
      : typeof dmSrc.baselineAvg === 'number'
      ? dmSrc.baselineAvg
      : typeof lv.baselineAvg === 'number'
      ? lv.baselineAvg
      : typeof dmLv.baselineAvg === 'number'
      ? dmLv.baselineAvg
      : null;

  const jobSize =
    src.jobSize ||
    dmSrc.jobSize ||
    lv.jobSize ||
    dmLv.jobSize ||
    null;

  const urgency =
    src.urgency ||
    dmSrc.urgency ||
    lv.urgency ||
    dmLv.urgency ||
    null;

  const confidence =
    src.confidence ||
    dmSrc.confidence ||
    lv.confidence ||
    dmLv.confidence ||
    null;

  return { raw, jobSize, urgency, confidence };
}




function getBaselineRange(lead, dm) {
  const src = lead || {};
  const dmSrc = dm || {};
  const lv = src.leadValue || {};
  const dmLv = dmSrc.leadValue || {};

  const low =
    typeof src.baselineLow === 'number'
      ? src.baselineLow
      : typeof dmSrc.baselineLow === 'number'
      ? dmSrc.baselineLow
      : typeof lv.baselineLow === 'number'
      ? lv.baselineLow
      : typeof dmLv.baselineLow === 'number'
      ? dmLv.baselineLow
      : null;

  const high =
    typeof src.baselineHigh === 'number'
      ? src.baselineHigh
      : typeof dmSrc.baselineHigh === 'number'
      ? dmSrc.baselineHigh
      : typeof lv.baselineHigh === 'number'
      ? lv.baselineHigh
      : typeof dmLv.baselineHigh === 'number'
      ? dmLv.baselineHigh
      : null;

  const avg =
    typeof src.baselineAvg === 'number'
      ? src.baselineAvg
      : typeof dmSrc.baselineAvg === 'number'
      ? dmSrc.baselineAvg
      : typeof lv.baselineAvg === 'number'
      ? lv.baselineAvg
      : typeof dmLv.baselineAvg === 'number'
      ? dmLv.baselineAvg
      : null;

  // Fallback if any pieces are missing
  if (low == null && high == null && avg != null) {
    return {
      low: Math.round(avg * 0.6),
      high: Math.round(avg * 1.6),
      avg: Math.round(avg),
    };
  }

  return {
    low: low != null ? Math.round(low) : 0,
    high: high != null ? Math.round(high) : (avg != null ? Math.round(avg * 1.6) : 0),
    avg: avg != null ? Math.round(avg) : (low != null && high != null ? Math.round((low + high) / 2) : 0),
  };
}
function getDailyDmLimitForMarketSlot(market, scrapeId) {
  const m = String(market || '').toLowerCase();

  // extract slot number from "Nashville 3", "Memphis 10", etc
  const slotMatch = m.match(/\d+/);
  const slot = slotMatch ? Number(slotMatch[0]) : 1;

  // Nashville 1–5 → max 2/day
  if (m.includes('nashville') && [1,2,3,4,5].includes(slot)) {
    return 2;
  }

  // Memphis 10 → max 2/day
  if (m.includes('memphis') && slot === 10) {
    return 2;
  }

  return null; // no cap
}
const handleCopyLink = async (url) => {
  if (!url) return;
  try {
    await navigator.clipboard.writeText(url);
  } catch (err) {
    console.error("Clipboard copy failed:", err);
  }
};
function getLeadValueReasoning(lead, dm) {
  const src = lead || {};
  const dmSrc = dm || {};
  const lv = src.leadValue || {};
  const dmLv = dmSrc.leadValue || {};

  return (
    lv.reasoning ||
    dmLv.reasoning ||
    src.reasoning ||
    dmSrc.reasoning ||
    null
  );
}
// NEW: helper to build the AI lead value label + tooltip
// It will look on the lead first, then on the DM doc.
function getLeadValueMeta(lead, dm) {
  const { raw, jobSize, urgency, confidence } = extractLeadValueSource(
    lead,
    dm
  );

  if (raw == null) return null;

  const value = Math.round(raw);

  const pieces = [];
  if (jobSize) pieces.push(`Job size: ${jobSize}`);
  if (urgency) pieces.push(`Urgency: ${urgency}`);
  if (confidence) pieces.push(`Confidence: ${confidence}`);

  const tooltip =
    pieces.length > 0
      ? pieces.join(' • ')
      : 'AI-estimated ticket value';

  return {
    label: `$${value} est`,
    tooltip,
  };
}
// Normalize market labels so "NOVA", "Northern VA", etc. all map consistently
// Normalize market labels (including "Northern Virginia 2/3/4", "NOVA", etc.)
// Normalize market labels (including numbered variants).
// IMPORTANT: only returns a known market string or null.
const normalizeMarket = (val) => {
  if (!val) return null;
  const s = String(val).trim().toLowerCase();

  // Northern Virginia / NOVA (including numbered variants)
  if (
    s.includes('nova') ||
    s.includes('northern virginia') ||
    s.includes('northern va') ||
    s.includes('northern-virginia') ||
    s === 'va'
  ) {
    return 'Northern Virginia';
  }
  if (s.includes('southfl') || s.includes('south fl') || s.includes('south florida')) return 'SouthFL';
  if (s.includes('houston')) return 'Houston';
  if (s.includes('memphis')) return 'Memphis';
    if (s.includes('nashville')) return 'Nashville';
  if (s.includes('miami')) return 'Miami';
  if (s.includes('dallas')) return 'Dallas';

  if (s.includes('atlanta')) return 'Atlanta';
  if (s.includes('denver')) return 'Denver';
  if (s.includes('panhandle') || s.includes('florida panhandle') || s.includes('fl panhandle')) return 'Panhandle';
  if (s.includes('orlando')) return 'Orlando';
  if (s.includes('connecticut')) return 'Connecticut';
  if (s.includes('raleigh')) return 'Raleigh';
  if (s.includes('baltimore')) return 'Baltimore';
  if (s.includes('fredericksburg')) return 'Fredericksburg';
  if (s.includes('richmond')) return 'Richmond';
  if (s.includes('norfolk')) return 'Norfolk';
  if (s.includes('greensboro')) return 'Greensboro';
  if (s.includes('wilmington')) return 'WilmingtonNC';
  if (s.includes('myrtle')) return 'MyrtleBeach';
  if (s.includes('dmv md') || s.includes('dmv-md') || s.includes('dmvmddc')) return 'DmvMdDc';
  if (s.includes('dmv va') || s.includes('dmv-va') || s.includes('dmvva')) return 'DmvVa';
  if (s.includes('charlottesville')) return 'Charlottesville';
  if (s.includes('charlotte') && !s.includes('charlottesville')) return 'Charlotte';
  if (s === 'la' || /^la\s*\d+$/.test(s) || s.includes('los angeles') || s.includes('losangeles')) return 'LosAngeles';
if (s.includes('ftmyers') || s.includes('ft myers') || s.includes('fort myers')) {
  return 'FtMyers';
}
  // Tampa (including "Tampa 2", etc.)
  if (s.includes('tampa')) return 'Tampa';

  // Long Island (handle "LongIsland", "Long Island 2", etc.)
  const noSpace = s.replace(/\s+/g, '');
  if (noSpace.includes('longisland')) return 'Long Island';

  // Unknown strings return null, not the raw value
  return null;
};




// 1) explicit market field
// 2) scrapeId / batchId / id (e.g., "northern-virginia-3")
// 3) document path as a last resort
// 1) explicit market field (e.g. "Memphis 4")
// 2) scrapeId / batchId / id (if they actually encode a market)
// 3) document path as a last resort
const inferMarketFromDoc = (docSnap, data = {}) => {
  // 1) explicit market on the document
  const explicit =
    data.market ??
    (typeof docSnap.get === 'function' ? docSnap.get('market') : undefined);

  let normalized = normalizeMarket(explicit);
  if (normalized) return normalized;

  // 2) any scrape/batch identifiers that might contain "memphis", "nova", "houston"
  const scrapeHint =
    data.scrapeId ??
    data.batchId ??
    data.id ??
    (typeof docSnap.get === 'function' ? docSnap.get('scrapeId') : undefined);

  normalized = normalizeMarket(scrapeHint);
  if (normalized) return normalized;

  // 3) finally, infer from the collection path
  // 3) finally, infer from the collection path
  const path = (docSnap.ref?.path || '').toLowerCase();

  // Check the more specific ones first so variants
  // don't get caught by plain "newscrapes".
  if (path.includes('newscrapeshouston')) return 'Houston';
  if (path.includes('newscrapesva')) return 'Northern Virginia';
  if (path.includes('newscrapesmiami')) return 'Miami';
  if (path.includes('newscrapesftmyers')) return 'FtMyers';
  if (path.includes('newscrapestampa')) return 'Tampa';
   if (path.includes('newscrapesnashville')) return 'Nashville';
     if (path.includes('newscrapesatlanta')) return 'Atlanta';
  if (path.includes('newscrapesdenver')) return 'Denver';
    if (path.includes('newscrapessouthfl')) return 'SouthFL';
  if (path.includes('newscrapesdallas')) return 'Dallas';
  if (path.includes('newscrapespanhandle')) return 'Panhandle';
if (path.includes('newscrapesorlando')) return 'Orlando';
  if (path.includes('newscrapeslongisland')) return 'Long Island';
  if (path.includes('newscrapesconnecticut')) return 'Connecticut';
  if (path.includes('newscrapesraleigh')) return 'Raleigh';
  if (path.includes('newscrapesbaltimore')) return 'Baltimore';
  if (path.includes('newscrapesfredericksburg')) return 'Fredericksburg';
  if (path.includes('newscrapesrichmond')) return 'Richmond';
  if (path.includes('newscrapesnorfolk')) return 'Norfolk';
  if (path.includes('newscrapesgreensboro')) return 'Greensboro';
  if (path.includes('newscrapeswilmingtonnc')) return 'WilmingtonNC';
  if (path.includes('newscrapesmyrtlebeach')) return 'MyrtleBeach';
  if (path.includes('newscrapesdmvmddc')) return 'DmvMdDc';
  if (path.includes('newscrapesdmvva')) return 'DmvVa';
  if (path.includes('newscrapescharlottesville')) return 'Charlottesville';
  if (path.includes('newscrapescharlotte') && !path.includes('newscrapescharlottesville')) return 'Charlotte';
  if (path.includes('newscrapeslosangeles')) return 'LosAngeles';
  if (path.includes('newscrapes')) return 'Memphis';

  return null;
};

export default function PropertyGuysDashboard() {
  // Metrics
  const [totalPostsVettedToday, setTotalPostsVettedToday] = useState(0);
  const [totalLeadsToday, setTotalLeadsToday] = useState(0);
  const [totalDmsToday, setTotalDmsToday] = useState(0);
  const [serviceCountsToday, setServiceCountsToday] = useState({});
  const [totalLeadsCapturedToday, setTotalLeadsCapturedToday] = useState(0);
  const [metricsLoading, setMetricsLoading] = useState(true);
  const [metricsError, setMetricsError] = useState('');
  const [leadsCapturedToday, setLeadsCapturedToday] = useState(0);
  const [todayLeads, setTodayLeads] = useState([]);
  const [openStat, setOpenStat] = useState(null); // 'day' | 'ai' | null

  // Weekly DM report — who we messaged, for the client's end-of-week summary.
  const [dmReportOpen, setDmReportOpen] = useState(false);
  const [dmReportWeek, setDmReportWeek] = useState(() => dayjs().startOf('week'));
  const [dmReportRows, setDmReportRows] = useState([]);
  const [dmReportLoading, setDmReportLoading] = useState(false);
  const [dmReportError, setDmReportError] = useState('');
  const [dmReportAllMarkets, setDmReportAllMarkets] = useState(true);

  
const [copiedResponseIdx, setCopiedResponseIdx] = useState(null);
  const [totalLeadRevenueToday, setTotalLeadRevenueToday] = useState(0);
  const [avgLeadValueToday, setAvgLeadValueToday] = useState(0);
  const [selectedService, setSelectedService] = useState(null);
  const [showCoverageMap, setShowCoverageMap] = useState(false);
  // Scrapes + leads + DMs
  const [scrapes, setScrapes] = useState([]);
  const [scrapesLoading, setScrapesLoading] = useState(true);
const [markDmedOpen, setMarkDmedOpen] = useState(false);
const [markDmedLead, setMarkDmedLead] = useState(null);
const [markDmedAccount, setMarkDmedAccount] = useState('Memphis 1');
const [markDmedSaving, setMarkDmedSaving] = useState(false);
  const [leadTimerNowMs, setLeadTimerNowMs] = useState(() => Date.now());
  const [scrapesError, setScrapesError] = useState('');
const POSTS_PER_SCRAPE = 25; // assumed kept posts per scrape
  const [scrapeLeads, setScrapeLeads] = useState({});
  const [scrapeLeadsLoading, setScrapeLeadsLoading] = useState({});
  const [scrapeLeadsError, setScrapeLeadsError] = useState({});
  const [scrapeDms, setScrapeDms] = useState({});
    const [valueModalOpen, setValueModalOpen] = useState(false);
  const [valueModalPayload, setValueModalPayload] = useState(null);
const [dateMode, setDateMode] = useState('single'); // 'single' | 'range'
const [singleDate, setSingleDate] = useState(dayjs()); // default today
const [rangeStart, setRangeStart] = useState(dayjs());
const [rangeEnd, setRangeEnd] = useState(dayjs());
  const [ghlToday, setGhlToday] = useState(null);
const [ghl7Days, setGhl7Days] = useState(null);
const [loadingGhl, setLoadingGhl] = useState(true);
const [dmItemsByDay, setDmItemsByDay] = useState({}); // { 'YYYY-MM-DD': DM[] }
const [allowedScrapeIds, setAllowedScrapeIds] = useState(new Set());
const [dmCalendarOpen, setDmCalendarOpen] = useState(false);
const [dmCountsByDay, setDmCountsByDay] = useState({});
const [dmMonth, setDmMonth] = useState(dayjs());     // which month is displayed
const [dmSelectedDay, setDmSelectedDay] = useState(dayjs()); // optional selection
  const [scrapeDmsLoading, setScrapeDmsLoading] = useState({});
const [selectedMarket, setSelectedMarket] = useState('Memphis');
  const [healthOpen, setHealthOpen] = useState(false);
  const [todayDmsMap, setTodayDmsMap] = useState({});
  // NEW: expanded state for each scrape (details shown only when clicked)
  const [expandedScrapes, setExpandedScrapes] = useState({});
    const [runStates, setRunStates] = useState({}); // { [scrapeId]: 'idle' | 'running' | 'ok' | 'error' }
    const [dmModalMarket, setDmModalMarket] = useState('Memphis');
const [ghlStats, setGhlStats] = useState({
  va: { inboundCalls: 0, inboundSms: 0 },
  memphis: { inboundCalls: 0, inboundSms: 0 },
  houston: { inboundCalls: 0, inboundSms: 0 },
  newLeads: 0,
});




const dmMonthKey = dmMonth.format('YYYY-MM');

const dmMonthEntries = Object.entries(dmItemsByDay).filter(([dateKey]) =>
  dateKey.startsWith(dmMonthKey)
);

const dmMonthTotal = dmMonthEntries.reduce(
  (sum, [, items]) => sum + (items?.length || 0),
  0
);

const allKnownLeads = useMemo(() => {
  const merged = [
    ...(Array.isArray(todayLeads) ? todayLeads : []),
    ...Object.values(scrapeLeads || {}).flatMap((arr) =>
      Array.isArray(arr) ? arr : []
    ),
  ];

  const byKey = new Map();

  merged.forEach((lead) => {
    const key =
      lead.id ||
      lead.postId ||
      lead.permalink ||
      lead.postUrl;

    if (!key) return;

    const existing = byKey.get(key);

    // Prefer the richer / newer version
    if (!existing) {
      byKey.set(key, lead);
      return;
    }

    byKey.set(key, {
      ...existing,
      ...lead,
    });
  });

  return Array.from(byKey.values());
}, [todayLeads, scrapeLeads]);
const dmActiveDays = dmMonthEntries.filter(([, items]) => (items?.length || 0) > 0).length;

const dmDaysInMonth = dmMonth.daysInMonth();

const dmDailyAverageAllDays = dmDaysInMonth ? (dmMonthTotal / dmDaysInMonth) : 0;
const dmDailyAverageActiveDays = dmActiveDays ? (dmMonthTotal / dmActiveDays) : 0;

const manualDmCountsByAccount = useMemo(() => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const startOfTomorrow = new Date(startOfToday);
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);

  const counts = {};

  MEMPHIS_DM_ACCOUNTS.forEach((account) => {
    counts[account] = 0;
  });

  allKnownLeads.forEach((lead) => {
    if (!lead.manualDmed) return;
    if (!lead.manualDmedAccount) return;

    const ts =
      lead.manualDmedAt?.toDate?.() ||
      (lead.manualDmedAt instanceof Date
        ? lead.manualDmedAt
        : lead.manualDmedAt?.seconds
        ? new Date(lead.manualDmedAt.seconds * 1000)
        : null);

    if (!ts) return;
    if (ts < startOfToday || ts >= startOfTomorrow) return;

    const leadMarket = normalizeMarket(lead.market || lead.scrapeId);
    const currentMarket = normalizeMarket(selectedMarket);

    if (leadMarket && currentMarket && leadMarket !== currentMarket) return;

    const account = String(lead.manualDmedAccount).trim();
    counts[account] = (counts[account] || 0) + 1;
  });

  return counts;
}, [allKnownLeads, selectedMarket]);

const { filterStart, filterEnd, label } = useMemo(() => {
  if (dateMode === 'range') {
    const s = rangeStart.startOf('day');
    const e = rangeEnd.startOf('day').add(1, 'day'); // exclusive end
    return {
      filterStart: s.toDate(),
      filterEnd: e.toDate(),
      label: `${s.format('MMM D')} – ${rangeEnd.format('MMM D')}`,
    };
  }

  const s = singleDate.startOf('day');
  const e = s.add(1, 'day'); // exclusive end
  return {
    filterStart: s.toDate(),
    filterEnd: e.toDate(),
    label: s.format('MMM D, YYYY'),
  };
}, [dateMode, singleDate, rangeStart, rangeEnd]);

const totalLeadsDmedToday = useMemo(() => {
  return allKnownLeads.filter((lead) => {
    if (!lead.manualDmed) return false;

    const ts =
      lead.manualDmedAt?.toDate?.() ||
      (lead.manualDmedAt instanceof Date
        ? lead.manualDmedAt
        : lead.manualDmedAt?.seconds
        ? new Date(lead.manualDmedAt.seconds * 1000)
        : null);

    if (!ts) return false;

    const leadMarket = normalizeMarket(lead.market || lead.scrapeId);
    const currentMarket = normalizeMarket(selectedMarket);

    if (leadMarket && currentMarket && leadMarket !== currentMarket) return false;

    return ts >= filterStart && ts < filterEnd;
  }).length;
}, [allKnownLeads, filterStart, filterEnd, selectedMarket]);

const avgResponseTimeTodaySeconds = useMemo(() => {
  const windowStart = new Date();
  windowStart.setHours(8, 30, 0, 0);

  const windowEnd = new Date();
  windowEnd.setHours(20, 30, 0, 0);

  const stoppedLeadTimes = todayLeads
    .filter((lead) => {
      const capturedAt = getLeadCapturedAtDate(lead);
      if (!capturedAt) return false;
      if (capturedAt < windowStart || capturedAt >= windowEnd) return false;

      const timerMeta = getLeadTimerMeta(lead, leadTimerNowMs);
      return timerMeta.isStopped && Number.isFinite(timerMeta.elapsedSeconds);
    })
    .map((lead) => getLeadTimerMeta(lead, leadTimerNowMs).elapsedSeconds);

  if (!stoppedLeadTimes.length) return null;

  const totalSeconds = stoppedLeadTimes.reduce((sum, secs) => sum + secs, 0);
  return Math.round(totalSeconds / stoppedLeadTimes.length);
}, [todayLeads, leadTimerNowMs]);

const avgResponseTimeTodayLabel = avgResponseTimeTodaySeconds != null
  ? formatLeadElapsed(avgResponseTimeTodaySeconds)
  : '—';

useEffect(() => {
  console.log('dmCalendarOpen:', dmCalendarOpen);
}, [dmCalendarOpen]);




useEffect(() => {
  if (!dmCalendarOpen) return;

  const start = dmMonth.startOf('month').startOf('day').toDate();
  const end = dmMonth.add(1, 'month').startOf('month').startOf('day').toDate();
  const marketFilter = normalizeMarket(dmModalMarket);

  const dmsQ = query(
    collectionGroup(db, 'dms'),
    where('createdAt', '>=', start),
    where('createdAt', '<', end)
  );

  const unsub = onSnapshot(dmsQ, (snap) => {
    const counts = {};
    const items = {};

    snap.forEach((docSnap) => {
      const data = docSnap.data() || {};

      const rawMarket = inferMarketFromDoc(docSnap, data);
      const docMarket = normalizeMarket(rawMarket);

      if (!docMarket || docMarket !== marketFilter) return;

      const ts =
        data.createdAt?.toDate?.() ||
        (data.createdAt instanceof Date ? data.createdAt : null);

      if (!ts) return;

      const key = dayjs(ts).format('YYYY-MM-DD');

      counts[key] = (counts[key] || 0) + 1;
      if (!items[key]) items[key] = [];

      items[key].push({
        id: docSnap.id,
        createdAt: ts,
        firstname: data.firstname || '',
        author: data.author || '',
        serviceType: data.serviceType || '',
        text: data.text || '',
        dmText: data.dmText || '',
        permalink: data.permalink || '',
        scrapeId: data.scrapeId || '',
      });
    });

    Object.keys(items).forEach((k) => {
      items[k].sort(
        (a, b) => (b.createdAt?.getTime?.() || 0) - (a.createdAt?.getTime?.() || 0)
      );
    });

    setDmCountsByDay(counts);
    setDmItemsByDay(items);

    console.log('[DM CALENDAR] matched days:', Object.keys(items).length);
    console.log(
      '[DM CALENDAR] total matched DMs:',
      Object.values(items).reduce((sum, arr) => sum + arr.length, 0)
    );
  });

  return () => unsub();
}, [dmCalendarOpen, dmMonth, dmModalMarket]);



useEffect(() => {
  const keyStart = dayjs(filterStart).format('YYYY-MM-DD');
  const keyEndInclusive = dayjs(filterEnd).subtract(1, 'day').format('YYYY-MM-DD');

  const q = query(
    collection(db, 'ghlEvents'),
    where('dateKey', '>=', keyStart),
    where('dateKey', '<=', keyEndInclusive)
  );

  const unsub = onSnapshot(q, (snapshot) => {
    // your existing aggregation logic
  });

  return () => unsub();
}, [filterStart, filterEnd]);


useEffect(() => {
  const fetchData = async () => {
    try {
      const todayRes = await fetch("https://api-vasejd2hkq-uc.a.run.app/ghl/contactsTodayByMarket");
      const todayJson = await todayRes.json();

      const sevenRes = await fetch("https://api-vasejd2hkq-uc.a.run.app/ghl/contactsLast7DaysByMarket");
      const sevenJson = await sevenRes.json();

      console.log('[GHL] contactsTodayByMarket', todayJson);
      console.log('[GHL] contactsLast7DaysByMarket', sevenJson);

      setGhlToday(todayJson);
      setGhl7Days(sevenJson);
    } catch (err) {
      console.error("GHL Dashboard Fetch Error:", err);
    } finally {
      setLoadingGhl(false);
    }
  };

  fetchData();
}, []);


  // These three stat cards used to print `new Date()` — the real current date —
  // while their VALUES came from filterStart/filterEnd. Pick Sep 9 and the
  // numbers changed but every heading still read "Sep 10". Derive the heading
  // from the same selection that drives the numbers, and only say "Today" when
  // the selected day actually is today.
  const statIsToday =
    dateMode !== 'range' && singleDate.startOf('day').isSame(dayjs().startOf('day'));
  const statDateLabel = dateMode === 'range' ? label : singleDate.format('MMM D');
  const statTitle = (base) => (statIsToday ? `${base} Today` : base);

  // ── weekly DM report ──────────────────────────────────────────────────────
  // Source is the LEAD doc, not the `dms` collection: `dms` holds automated DM
  // records, while what the VA actually marks is manualDmed on the lead — and
  // the lead is where the person's details live (author, neighborhood, service,
  // post link). Market comes from the doc PATH, as everywhere else.
  useEffect(() => {
    if (!dmReportOpen) return;
    let alive = true;
    setDmReportLoading(true);
    setDmReportError('');

    (async () => {
      try {
        const start = dmReportWeek.startOf('day').toDate();
        const end = dmReportWeek.add(7, 'day').startOf('day').toDate();
        const snap = await getDocs(query(
          collectionGroup(db, 'leads'),
          where('manualDmed', '==', true),
          where('manualDmedAt', '>=', start),
          where('manualDmedAt', '<', end),
          orderBy('manualDmedAt', 'desc')
        ));

        const rows = [];
        snap.forEach((docSnap) => {
          const v = docSnap.data() || {};
          const market = normalizeMarket(inferMarketFromDoc(docSnap, v)) || 'Unknown';
          const when = v.manualDmedAt?.toDate?.()
            || (v.manualDmedAt?.seconds ? new Date(v.manualDmedAt.seconds * 1000) : null);
          if (!when) return;
          // the scraper leaves phone numbers in the post body, never in phones[]
          const phoneMatch = String(v.text || '')
            .match(/(?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/);
          rows.push({
            id: docSnap.id,
            when,
            day: dayjs(when).format('ddd MMM D'),
            time: dayjs(when).format('h:mm A'),
            name: v.author || v.headerName || 'Unknown',
            neighborhood: v.neighborhood || v.headerNeighborhood || '',
            market,
            service: v.serviceType || v.classification || '',
            dmedBy: v.manualDmedAccount || '',
            phone: phoneMatch ? phoneMatch[0].trim() : '',
            request: String(v.text || '').replace(/\s+/g, ' ').trim(),
            postUrl: v.permalink || v.postUrl || '',
          });
        });

        if (alive) { setDmReportRows(rows); setDmReportLoading(false); }
      } catch (e) {
        if (alive) { setDmReportError(e?.message || 'Failed to load'); setDmReportLoading(false); }
      }
    })();

    return () => { alive = false; };
  }, [dmReportOpen, dmReportWeek]);

  // Michael & Son's billable zones plus Northern Virginia, fixed so a market with
  // zero DMs still shows as a row — an absent row reads as "no data", a zero row
  // reads as "nobody was messaged", and those mean different things to the client.
  // This report goes to Michael & Son, so it must contain ONLY their markets:
  // Memphis, Dallas and LA are other clients' and are filtered out everywhere
  // below, not just left out of the grid.
  const MS_REPORT_MARKETS = [
    ['Baltimore', 'Baltimore'], ['Raleigh', 'Raleigh'],
    ['Fredericksburg', 'Fredericksburg'], ['Richmond', 'Richmond'],
    ['Norfolk', 'Norfolk'], ['Charlottesville', 'Charlottesville'],
    ['Charlotte', 'Charlotte'], ['Greensboro', 'Greensboro'],
    ['WilmingtonNC', 'Wilmington NC'], ['MyrtleBeach', 'Myrtle Beach'],
    ['DmvVa', 'DMV VA'], ['DmvMdDc', 'DMV MD/DC'],
    ['Northern Virginia', 'NOVA'],
  ];
  const MS_REPORT_KEYS = new Set(MS_REPORT_MARKETS.map(([k]) => k));
  // Everything downstream — the grid, the detail list and the CSV — reads from
  // this, so no other client's market can reach a sheet sent to Michael & Son.
  const msReportRows = useMemo(
    () => dmReportRows.filter((r) => MS_REPORT_KEYS.has(r.market)),
    [dmReportRows] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const dmReportMatrix = useMemo(() => {
    const days = Array.from({ length: 7 }, (_, i) => dmReportWeek.add(i, 'day'));
    const cells = {};
    msReportRows.forEach((r) => {
      const key = `${r.market}|${dayjs(r.when).format('YYYY-MM-DD')}`;
      cells[key] = (cells[key] || 0) + 1;
    });
    const rows = MS_REPORT_MARKETS.map(([key, label]) => {
      const counts = days.map((d) => cells[`${key}|${d.format('YYYY-MM-DD')}`] || 0);
      return { key, label, counts, total: counts.reduce((a, b) => a + b, 0) };
    });
    const dayTotals = days.map((_, i) => rows.reduce((a, r) => a + r.counts[i], 0));
    const peak = Math.max(1, ...rows.flatMap((r) => r.counts));
    const grand = dayTotals.reduce((a, b) => a + b, 0);
    // Every row in scope is now a reported market, so the grid total IS the
    // report total — there is no longer an "other markets" remainder to explain.
    return { days, rows, dayTotals, peak, grand, other: 0 };
  }, [msReportRows, dmReportWeek]); // eslint-disable-line react-hooks/exhaustive-deps

  const dmReportVisible = useMemo(() => (
    dmReportAllMarkets
      ? msReportRows
      : msReportRows.filter((r) => r.market === normalizeMarket(selectedMarket))
  ), [msReportRows, dmReportAllMarkets, selectedMarket]);

  const downloadDmReportCsv = () => {
    const cols = ['Date', 'Time', 'Name', 'Neighborhood', 'Market', 'Service',
                  'DMed By', 'Phone', 'Request', 'Post URL'];
    // quote everything and double embedded quotes — request text contains commas,
    // quotes and newlines, which would otherwise shear the columns apart
    const esc = (x) => `"${String(x ?? '').replace(/"/g, '""')}"`;
    const lines = [cols.join(',')];
    dmReportVisible.forEach((r) => lines.push([
      r.day, r.time, r.name, r.neighborhood, r.market, r.service,
      r.dmedBy, r.phone, r.request, r.postUrl,
    ].map(esc).join(',')));
    const scope = dmReportAllMarkets ? 'all-markets' : normalizeMarket(selectedMarket);
    const blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `dm-report_${scope}_${dmReportWeek.format('YYYY-MM-DD')}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };

  // Every stored lead already has verdict:'good' — the scraper only writes
  // leads that passed the first vetter, so that field can't separate anything.
  // `finalGateVerdict` is the second-stage AI call and is the real signal:
  // ~113 good / ~106 bad on a typical day. Deliberately NOT wouldHaveBeenDmed,
  // which also goes false for operational reasons like
  // author_already_dmed_today and so isn't a pure quality judgement.
  const aiGoodLeads = todayLeads.filter((l) => l.finalGateVerdict === 'good');

  const startOfDay = new Date();
startOfDay.setHours(0, 0, 0, 0);

  

// Primary + fallback market keys as used by the GHL endpoints
// contactsTodayByMarket / contactsLast7DaysByMarket should be returning
// something like: { totals: { memphis, virginia, houston, all }, ... }
const marketLabelShort = (() => {
  const m = normalizeMarket(selectedMarket) || selectedMarket;

  if (m === 'Northern Virginia') return 'NOVA';
  if (m === 'Houston') return 'Houston';
  if (m === 'Tampa') return 'Tampa';
  if (m === 'Dallas') return 'Dallas';
  if (m === 'Atlanta') return 'Atlanta';
if (m === 'Denver') return 'Denver';
  if (m === 'SouthFL') return 'South FL';
if (m === 'Panhandle') return 'Panhandle';
if (m === 'Orlando') return 'Orlando';
  if (m === 'Long Island') return 'Long Island';
  if (m === 'Nashville') return 'Nashville';
  if (m === 'Miami') return 'Miami';
  if (m === 'FtMyers') return 'FtMyers';
  return 'Memphis';
})();
// keys used by the contactsToday / contactsLast7 endpoints
const ghlPrimaryKey =
  selectedMarket === 'Northern Virginia'
    ? 'virginia'
    : selectedMarket === 'Houston'
    ? 'houston'
    : 'memphis';

const ghlAltKey =
  selectedMarket === 'Northern Virginia'
    ? 'va'
    : selectedMarket === 'Houston'
    ? 'houston'
    : 'memphis';

// Inbound calls / SMS from ghlEvents (today, per market)
const inboundCallsToday = (() => {
  if (selectedMarket === 'Northern Virginia') {
    return ghlStats.va?.inboundCalls ?? 0;
  }
  if (selectedMarket === 'Houston') {
    return ghlStats.houston?.inboundCalls ?? 0;
  }
  return ghlStats.memphis?.inboundCalls ?? 0;
})();

const inboundSmsToday = (() => {
  if (selectedMarket === 'Northern Virginia') {
    return ghlStats.va?.inboundSms ?? 0;
  }
  if (selectedMarket === 'Houston') {
    return ghlStats.houston?.inboundSms ?? 0;
  }
  return ghlStats.memphis?.inboundSms ?? 0;
})();
// Helper to safely pull counts from the contactsToday / contactsLast7 responses
const getTodayLeadsForMarket = () => {
  if (!ghlToday) return 0;

  // Prefer totals if present
  const fromTotals =
    ghlToday.totals?.[ghlPrimaryKey] ??
    ghlToday.totals?.[ghlAltKey];

  if (typeof fromTotals === 'number') return fromTotals;

  // Fallback: count from byMarket arrays
  const fromByMarket =
    ghlToday.byMarket?.[ghlPrimaryKey]?.length ??
    ghlToday.byMarket?.[ghlAltKey]?.length;

  return fromByMarket ?? 0;
};

const getLast7LeadsForMarket = () => {
  if (!ghl7Days) return 0;

  const fromTotals =
    ghl7Days.totals?.[ghlPrimaryKey] ??
    ghl7Days.totals?.[ghlAltKey];

  return typeof fromTotals === 'number' ? fromTotals : 0;
};

// New leads today (current market) from GHL API
const newLeadsToday = loadingGhl ? 0 : getTodayLeadsForMarket();
  const handleRunScrape = async (scrape) => {
    if (!scrape || !scrape.id) return;

    const scrapeId = scrape.id;

    // mark as running for this row
    setRunStates((prev) => ({ ...prev, [scrapeId]: 'running' }));

    // Infer logical market for nd50 (Memphis / NOVA / Houston etc.)
    const rawMarket =
      scrape.market ||
      scrape.marketLabel ||
      scrape.scrapeMarket ||
      '';

    const inferredMarket = normalizeMarket(
      rawMarket || scrape.scrapeId || scrape.id || selectedMarket
    );

    let marketForNd50 = inferredMarket || selectedMarket || 'Memphis';

    // Build payload for the nd50 runner
    const payload = {
      MARKET: marketForNd50,
      MARKET_LABEL: rawMarket || marketForNd50,
      SCRAPE_ID: scrape.scrapeId || scrape.batchId || scrape.id || '',
      MAX_POSTS: 20,
      RETURN_KEPT: '1',
      SEND_SESSION: '1',
      LOCAL_ENRICH_ONLY: '0',
      LOCAL_ENRICH_FALLBACK: '1',
      ND_COLLECTOR_VISUALS: '0',
      ND_ENRICH_VISUALS: '0',
      ND_ENRICH_NO_INTERCEPT: '1',
      SIMPLE_PREVIEW: '0',
      DEBUG: '0',
      DEBUG_ENRICH: '0',
    };

    try {
      const resp = await fetch(
        'https://api-vasejd2hkq-uc.a.run.app/nextdoor/nd50/run',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status}`);
      }

      // show success state
      setRunStates((prev) => ({ ...prev, [scrapeId]: 'ok' }));

      // optionally refresh metrics after a short delay
      setTimeout(() => {
        fetchMetrics();
      }, 1500);
    } catch (err) {
      console.error('[PropertyGuysDashboard] manual run error:', err);
      setRunStates((prev) => ({ ...prev, [scrapeId]: 'error' }));
    } finally {
      // clear status after a bit so button goes back to normal
      setTimeout(() => {
        setRunStates((prev) => ({ ...prev, [scrapeId]: 'idle' }));
      }, 4000);
    }
  };
// All markets today (optional, if you ever want it on the card)
const newLeadsTodayAllMarkets = loadingGhl
  ? 0
  : (
      ghlToday?.totals?.all ??
      (Array.isArray(ghlToday?.contactsToday)
        ? ghlToday.contactsToday.length
        : 0)
    );

// Last 7 days inbound leads from GHL API (current market)
const last7LeadsForMarket = loadingGhl ? 0 : getLast7LeadsForMarket();
function DmCountDay(props) {
  const { day, outsideCurrentMonth, ...other } = props;
  const dateKey = day.format('YYYY-MM-DD');
  const count = dmItemsByDay[dateKey]?.length || 0;
  const isSelected = dmSelectedDay && day.isSame(dmSelectedDay, 'day');

  return (
    <Badge
      overlap="circular"
      badgeContent={count > 0 ? count : undefined}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiBadge-badge': {
          minWidth: 20,
          height: 20,
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 900,
          px: 0.75,
          bgcolor: count > 0 ? '#16a34a' : undefined,
          color: '#fff',
          border: '2px solid white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
        },
      }}
    >
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        sx={{
          width: 42,
          height: 42,
          fontWeight: 800,
          borderRadius: 2.5,
          ...(count > 0 && !isSelected
            ? {
                backgroundColor: 'rgba(22,163,74,0.10)',
                color: '#166534',
              }
            : {}),
        }}
      />
    </Badge>
  );
}

const MAX_DMS_PER_ACCOUNT_PER_DAY = 2;



// All markets last 7 days
const last7LeadsAllMarkets = loadingGhl
  ? 0
  : (ghl7Days?.totals?.all ?? 0);
  const anyLeadsLoading = useMemo(
    () => Object.values(scrapeLeadsLoading).some(Boolean),
    [scrapeLeadsLoading]
  );
  const anyDmsLoading = useMemo(
    () => Object.values(scrapeDmsLoading).some(Boolean),
    [scrapeDmsLoading]
  );

  const isLiveLoading = metricsLoading || scrapesLoading || anyLeadsLoading || anyDmsLoading;

  // ─────────────────────────────────────────────
  // Fetch TODAY metrics (leads + dms + scrapes)
  // ─────────────────────────────────────────────

 
  const handleOpenLeadValueModal = (lead, dm) => {
    if (!lead || !dm) return; // only care about DMed leads

    const { raw, jobSize, urgency, confidence } = extractLeadValueSource(
      lead,
      dm
    );

    if (raw == null || Number.isNaN(raw)) {
      // no usable value, skip opening
      return;
    }

    const baseline = getBaselineRange(lead, dm);

    setValueModalPayload({
      lead,
      dm,
      rawValue: Math.round(raw),
      jobSize,
      urgency,
      confidence,
      baseline,
    });
    setValueModalOpen(true);
  };

  const handleCloseLeadValueModal = () => {
    setValueModalOpen(false);
    setValueModalPayload(null);
  };

const fetchMetrics = async () => {
  setMetricsLoading(true);
  setMetricsError('');

  try {
const start = filterStart;
const end = filterEnd;


    // Normalize so "NOVA", "Northern VA", etc. all collapse to "Northern Virginia"
    const marketFilter = normalizeMarket(selectedMarket);

    // 1) DMs in last 24h, filtered by market
    const dmsQ = query(
      collectionGroup(db, 'dms'),
      where('createdAt', '>=', start),
      where('createdAt', '<', end)
    );
    const dmsSnap = await getDocs(dmsQ);

    const dmsMap = {};
    let dmsCount = 0;

    dmsSnap.forEach((docSnap) => {
      const data = docSnap.data() || {};

      const rawMarket = inferMarketFromDoc(docSnap, data);
      const docMarket = normalizeMarket(rawMarket);

      if (!docMarket || docMarket !== marketFilter) return;

      const key =
  data.postId ||
  data.permalink ||
  data.post_id ||
  data.threadUrl ||
  data.thread_url ||
  null;
      if (!key) return;

      dmsMap[key] = { id: docSnap.id, ...data };
      dmsCount += 1;
    });

    setTotalDmsToday(dmsCount);
    setTodayDmsMap(dmsMap);

    // 2) Leads in last 24h — ONLY ones that have a DM, filtered by market
    const leadsQ = query(
      collectionGroup(db, 'leads'),
      where('createdAt', '>=', start),
      where('createdAt', '<', end)
    );
    const leadsSnap = await getDocs(leadsQ);

    const counts = {};
    SERVICE_LABELS.forEach((svc) => {
      counts[svc] = 0;
    });

    const todaysLeads = [];

leadsSnap.forEach((docSnap) => {
  const data = docSnap.data() || {};

  const rawMarket = inferMarketFromDoc(docSnap, data);
  const docMarket = normalizeMarket(rawMarket);

  if (!docMarket || docMarket !== marketFilter) return;

  // NOTE: this used to `return` unless data.wouldHaveBeenDmed was true, which
  // silently dropped every lead that wasn't DM-eligible — 67% of NOVA's leads,
  // 70% of DMV MD/DC's. DM-sending is legacy/dead, so that flag is no longer a
  // meaningful filter for "captured leads"; it now only drives the green
  // highlight on a card. Count everything we captured.

  const svc = normalizeSvc(data.serviceType || data.classification);
  counts[svc] = (counts[svc] || 0) + 1;
todaysLeads.push({
  id: docSnap.id,
  ...data,
  scrapeId: docSnap.ref.parent.parent?.id || null,
  _svc: svc,
});
});

    // Compute total lead revenue + avg lead value for TODAY
    let totalRevenue = 0;
    let valuedCount = 0;

todaysLeads.forEach((lead) => {
  const { raw } = extractLeadValueSource(lead, null);

  if (raw != null && !Number.isNaN(raw)) {
    totalRevenue += raw;
    valuedCount += 1;
  }
});

    setTotalLeadRevenueToday(Math.round(totalRevenue));
    setAvgLeadValueToday(
      valuedCount > 0 ? Math.round(totalRevenue / valuedCount) : 0
    );

    setTotalLeadsToday(todaysLeads.length);
    setServiceCountsToday(counts);
    setTodayLeads(todaysLeads);


    if (selectedService && !counts[selectedService]) {
      setSelectedService(null);
    }

    

    

    


    
  } catch (err) {
    console.error('[PropertyGuysDashboard] metrics error:', err);
    setMetricsError(err?.message || 'Failed to load metrics');
  } finally {
    setMetricsLoading(false);
  }
};

useEffect(() => {
  fetchMetrics();
}, [selectedMarket]);
useEffect(() => {
  const interval = window.setInterval(() => {
    setLeadTimerNowMs(Date.now());
  }, 1000);

  return () => window.clearInterval(interval);
}, []);
useEffect(() => {
  // Match the dateKey used in the webhook (UTC yyyy-mm-dd)
  const todayKey = new Date().toISOString().slice(0, 15);

  const q = query(
    collection(db, 'ghlEvents'),
    where('dateKey', '==', todayKey)
  );

  const unsub = onSnapshot(q, (snapshot) => {
    const next = {
      va: { inboundCalls: 0, inboundSms: 0 },
      memphis: { inboundCalls: 0, inboundSms: 0 },
      newLeads: 0,
    };

   snapshot.forEach((doc) => {
  const e = doc.data();
  const type = e.type;
  const tags = (e.tags || []).map(t => t.toLowerCase());
  const direction = (e.direction || 'inbound').toLowerCase();

  // Count ALL new contacts
  if (type === 'contactCreated') {
    next.newLeads += 1;
  }

  // We only count inbound events by tag
  if (direction !== 'inbound') return;

  const isMemphis = tags.includes('source_memphis');
  const isVA = tags.includes('source_va');
  const isHouston = tags.includes('source_houston');

  if (type === 'call') {
    if (isMemphis) next.memphis.inboundCalls += 1;
    if (isVA) next.va.inboundCalls += 1;
    if (isHouston) next.houston.inboundCalls += 1;
  }

  if (type === 'sms') {
    if (isMemphis) next.memphis.inboundSms += 1;
    if (isVA) next.va.inboundSms += 1;
    if (isHouston) next.houston.inboundSms += 1;
  }
});
    

    setGhlStats(next);
  });

  return () => unsub();
}, []);

const handleMarkBadLead = async (lead) => {
  if (!lead?.id || !lead?.scrapeId) return;

  try {
    const rootCollection = rootCollectionFromMarket(
      lead.market || selectedMarket
    );

    const leadRef = doc(db, rootCollection, lead.scrapeId, 'leads', lead.id);
const capturedAt = getLeadCapturedAtDate(lead);
const elapsedSeconds = capturedAt
  ? Math.max(0, Math.floor((Date.now() - capturedAt.getTime()) / 1000))
  : null;

const timerUpdate = {
  captureTimerStoppedAt: serverTimestamp(),
};

if (elapsedSeconds != null) {
  timerUpdate.captureTimerStoppedSeconds = elapsedSeconds;
  timerUpdate.captureTimerStoppedLabel = formatLeadElapsed(elapsedSeconds);
}
    await updateDoc(leadRef, {
  isBadLead: true,
  badLeadAt: serverTimestamp(),
  ...timerUpdate,
});

setScrapeLeads((prev) => ({
  ...prev,
  [lead.scrapeId]: Array.isArray(prev[lead.scrapeId])
    ? prev[lead.scrapeId].map((item) =>
        item.id === lead.id
          ? {
              ...item,
              isBadLead: true,
              badLeadAt: new Date(),
              captureTimerStoppedAt: new Date(),
              captureTimerStoppedSeconds: elapsedSeconds,
              captureTimerStoppedLabel: formatLeadElapsed(elapsedSeconds),
            }
          : item
      )
    : prev[lead.scrapeId],
}));
console.log('[manualDmed] local scrapeLeads updated for:', {
  id: markDmedLead.id,
  scrapeId: markDmedLead.scrapeId,
  account: markDmedAccount,
});
   setTodayLeads((prev) =>
  prev.map((item) =>
    item.id === lead.id && item.scrapeId === lead.scrapeId
      ? {
          ...item,
          isBadLead: true,
          badLeadAt: new Date(),
          captureTimerStoppedAt: new Date(),
          captureTimerStoppedSeconds: elapsedSeconds,
          captureTimerStoppedLabel: formatLeadElapsed(elapsedSeconds),
        }
      : item
  )
);
    console.log('[manualDmed] local todayLeads attempted update for:', {
  id: markDmedLead.id,
  scrapeId: markDmedLead.scrapeId,
});
  } catch (err) {
    console.error('Failed to mark bad lead:', err);
  }
};

  // ─────────────────────────────────────────────
  // Live scrapes list from newscrapes (last 10)
  // ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// Live scrapes list from newscrapes / newscrapesVA (last 10)
// ─────────────────────────────────────────────
useEffect(() => {
  setScrapesLoading(true);
  setScrapesError('');

const rootCollection = rootCollectionFromMarket(selectedMarket);
  const scrapesRef = collection(db, rootCollection);
  const qScrapes = query(
    scrapesRef,
    orderBy('startedAt', 'desc'),
    limit(200)
  );

  const unsub = onSnapshot(
    qScrapes,
    (snap) => {
      const rows = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      console.log('[PGD] bottom-table rows count =', rows.length);

console.log(
  '[PGD] bottom-table first 20 rows =',
  rows.slice(0, 20).map((r) => ({
    id: r.id || r.scrapeId || r._id || null,
    market: r.market || null,
    status: r.status || null,
    newLeadsCount: r.newLeadsCount || 0,
    startedAt: r.startedAt?.toDate?.()?.toISOString?.() || r.startedAt || null,
    updatedAt: r.updatedAt?.toDate?.()?.toISOString?.() || r.updatedAt || null,
    endedAt: r.endedAt?.toDate?.()?.toISOString?.() || r.endedAt || null,
  }))
);


      setScrapes(rows);
      setScrapesLoading(false);
    },
    (err) => {
      console.error('[PropertyGuysDashboard] scrapes error:', err);
      setScrapesError(err?.message || 'Failed to load scrapes');
      setScrapesLoading(false);
    }
  );

  return () => unsub();
}, [db, selectedMarket]);
useEffect(() => {
  // every captured lead — see the note above about wouldHaveBeenDmed
  setTotalLeadsCapturedToday(todayLeads.length);
}, [todayLeads]);
  // ─────────────────────────────────────────────
  // Lazy-load leads + DMs for each scrape (on expand)
  // ─────────────────────────────────────────────
const fetchLeadsForScrape = async (scrape) => {
  const rowKey = scrape.id; // cache bucket for UI
  const alreadyHaveLeads = !!scrapeLeads[rowKey];
  const alreadyHaveDms = !!scrapeDms[rowKey];
  if (alreadyHaveLeads && alreadyHaveDms) return;

  setScrapeLeadsLoading((prev) => ({ ...prev, [rowKey]: true }));
  setScrapeLeadsError((prev) => ({ ...prev, [rowKey]: '' }));
  setScrapeDmsLoading((prev) => ({ ...prev, [rowKey]: true }));

  try {
    const rootCollection = rootCollectionFromMarket(selectedMarket);
    const parentDocId = scrape.id;     // Firestore doc path
    const batchId = scrape._id || null; // unique run id

    // Pull from the subcollection under the parent doc
    const leadsRef = collection(db, rootCollection, parentDocId, 'leads');
    const qLeads = query(leadsRef, orderBy('capturedAt', 'desc'));
    const leadsSnap = await getDocs(qLeads);

    let leads = leadsSnap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    // Filter to just this run if lead docs carry a batch/run identifier
    if (batchId) {
      leads = leads.filter((lead) => {
        return (
          lead._id === batchId ||
          lead.batchId === batchId ||
          lead.scrapeId === batchId ||
          lead.runId === batchId
        );
      });
    }

    setScrapeLeads((prev) => ({ ...prev, [rowKey]: leads }));

    const dmsRef = collection(db, rootCollection, parentDocId, 'dms');
    const dmsSnap = await getDocs(dmsRef);

    let dms = dmsSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    if (batchId) {
      dms = dms.filter((dm) => {
        return (
          dm._id === batchId ||
          dm.batchId === batchId ||
          dm.scrapeId === batchId ||
          dm.runId === batchId
        );
      });
    }

    const dmMap = {};
    dms.forEach((data) => {
      const key =
        data.postId ||
        data.permalink ||
        data.post_id ||
        data.postURL ||
        null;

      if (!key) return;
      dmMap[key] = data;
    });

    setScrapeDms((prev) => ({ ...prev, [rowKey]: dmMap }));
  } catch (err) {
    console.error('[PropertyGuysDashboard] leads/dms error:', err);
    setScrapeLeadsError((prev) => ({
      ...prev,
      [rowKey]: err?.message || 'Failed to load leads',
    }));
  } finally {
    setScrapeLeadsLoading((prev) => ({ ...prev, [rowKey]: false }));
    setScrapeDmsLoading((prev) => ({ ...prev, [rowKey]: false }));
  }
};

  const selectedServiceLeads = useMemo(() => {
    if (!selectedService) return [];
    return todayLeads
      .filter((lead) => lead._svc === selectedService)
      .sort((a, b) => {
        const da = tsToDate(a.createdAt)?.getTime() || 0;
        const db = tsToDate(b.createdAt)?.getTime() || 0;
        return db - da;
      });
  }, [selectedService, todayLeads]);
  // GHL per-market derived stats for the currently selected market

  const todayDmedLeads = useMemo(() => {
  return todayLeads
    .map((lead) => {
      const key =
        lead.postId ||
        lead.permalink ||
        lead.post_id ||
        lead.threadUrl ||
        lead.thread_url ||
        null;

      if (!key) return null;

      const dm = todayDmsMap[key];
      if (!dm) return null;

      const createdAt =
        tsToDate(dm.createdAt) ||
        tsToDate(lead.createdAt) ||
        null;

      const svc =
        lead._svc ||
        normalizeSvc(lead.serviceType || lead.classification);

      return { lead, dm, key, createdAt, svc };
    })
    .filter(Boolean)
    .sort(
      (a, b) =>
        (b.createdAt?.getTime() || 0) -
        (a.createdAt?.getTime() || 0)
    );
}, [todayLeads, todayDmsMap]);



useEffect(() => {
  console.log('[manualDmed] counts by account', manualDmCountsByAccount);
}, [manualDmCountsByAccount]);

useEffect(() => {
  console.log('[manualDmed] totalLeadsDmedToday', totalLeadsDmedToday);
}, [totalLeadsDmedToday]);

  // NEW: click handler to expand/collapse a scrape row
const handleToggleScrape = (scrape) => {
  const rowKey = scrape.id; // UI expansion key can stay this
  const isCurrentlyExpanded = !!expandedScrapes[rowKey];

  if (!isCurrentlyExpanded) {
    fetchLeadsForScrape(scrape);
  }

  setExpandedScrapes((prev) => ({
    ...prev,
    [rowKey]: !isCurrentlyExpanded,
  }));
};

const extractPhoneNumber = (text = '') => {
  const phoneRegex =
    /(\+?1[\s.-]?)?(\(?\d{3}\)?[\s.-]?|\d{3}[\s.-]?)\d{3}[\s.-]?\d{4}/g;

  const match = text.match(phoneRegex);
  return match ? match[0] : null;
};

const handleLeftComment = async (lead) => {
  if (!lead?.id || !lead?.scrapeId) return;

  try {
    const rootCollection = rootCollectionFromMarket(
      lead.market || selectedMarket
    );

    const leadRef = doc(db, rootCollection, lead.scrapeId, 'leads', lead.id);

    await updateDoc(leadRef, {
      leftCommented: true,
      leftCommentedAt: serverTimestamp(),
    });

    setScrapeLeads((prev) => ({
      ...prev,
      [lead.scrapeId]: Array.isArray(prev[lead.scrapeId])
        ? prev[lead.scrapeId].map((item) =>
            item.id === lead.id
              ? {
                  ...item,
                  leftCommented: true,
                  leftCommentedAt: new Date(),
                }
              : item
          )
        : prev[lead.scrapeId],
    }));

    setTodayLeads((prev) =>
      prev.map((item) =>
        item.id === lead.id && item.scrapeId === lead.scrapeId
          ? {
              ...item,
              leftCommented: true,
              leftCommentedAt: new Date(),
            }
          : item
      )
    );
  } catch (err) {
    console.error('Failed to mark left commented:', err);
  }
};
const handleOpenMarkDmedModal = (lead) => {
  setMarkDmedLead(lead);
  setMarkDmedAccount('Memphis 1');
  setMarkDmedOpen(true);
};



const handleConfirmMarkDmed = async () => {
 if (!markDmedLead) return;

  const usedCount = manualDmCountsByAccount[markDmedAccount] || 0;
  const maxForSelectedAccount = getMaxDMsForAccount(markDmedAccount);

  if (usedCount >= maxForSelectedAccount) return;

  try {
    setMarkDmedSaving(true);

    if (!markDmedLead.scrapeId) {
      throw new Error('Missing scrapeId on selected lead');
    }

    const rootCollection = rootCollectionFromMarket(
      markDmedLead.market || selectedMarket
    );

    const leadRef = doc(
      db,
      rootCollection,
      markDmedLead.scrapeId,
      'leads',
      markDmedLead.id
    );
const capturedAt = getLeadCapturedAtDate(markDmedLead);
const elapsedSeconds = capturedAt
  ? Math.max(0, Math.floor((Date.now() - capturedAt.getTime()) / 1000))
  : null;

const timerUpdate = {
  captureTimerStoppedAt: serverTimestamp(),
};

if (elapsedSeconds != null) {
  timerUpdate.captureTimerStoppedSeconds = elapsedSeconds;
  timerUpdate.captureTimerStoppedLabel = formatLeadElapsed(elapsedSeconds);
}
    await updateDoc(leadRef, {
  manualDmed: true,
  manualDmedAt: serverTimestamp(),
  manualDmedAccount: markDmedAccount,
  ...timerUpdate,
});

    console.log('[manualDmed] wrote doc path:', leadRef.path);



    const verifySnap = await getDocs(
  query(collection(db, rootCollection, markDmedLead.scrapeId, 'leads'))
);

console.log(
  '[manualDmed] direct subcollection count after save:',
  verifySnap.size
);
console.log(
  '[manualDmed] direct subcollection docs:',
  verifySnap.docs.map((d) => ({
    id: d.id,
    manualDmed: d.data().manualDmed,
    manualDmedAt: d.data().manualDmedAt,
    market: d.data().market,
    scrapeId: d.data().scrapeId,
  }))
);


   setScrapeLeads((prev) => ({
  ...prev,
  [markDmedLead.scrapeId]: Array.isArray(prev[markDmedLead.scrapeId])
    ? prev[markDmedLead.scrapeId].map((lead) =>
        lead.id === markDmedLead.id
          ? {
              ...lead,
              manualDmed: true,
              manualDmedAccount: markDmedAccount,
              manualDmedAt: new Date(),
              captureTimerStoppedAt: new Date(),
              captureTimerStoppedSeconds: elapsedSeconds,
              captureTimerStoppedLabel: formatLeadElapsed(elapsedSeconds),
            }
          : lead
      )
    : prev[markDmedLead.scrapeId],
}));


    

setTodayLeads((prev) =>
  prev.map((lead) =>
    lead.id === markDmedLead.id &&
    lead.scrapeId === markDmedLead.scrapeId
      ? {
          ...lead,
          manualDmed: true,
          manualDmedAccount: markDmedAccount,
          manualDmedAt: new Date(),
          captureTimerStoppedAt: new Date(),
          captureTimerStoppedSeconds: elapsedSeconds,
          captureTimerStoppedLabel: formatLeadElapsed(elapsedSeconds),
        }
      : lead
  )
);

    setMarkDmedOpen(false);
    setMarkDmedLead(null);
    setMarkDmedAccount('Memphis 1');
  } catch (err) {
    console.error('Failed to mark lead as manually DMed:', err);
  } finally {
    setMarkDmedSaving(false);
  }
};


  // ─────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        px: 2,
        py: 4,
        background:
          'radial-gradient(circle at 0% 0%, #1e293b 0, #020617 35%, #020617 60%, #020617 100%)',
        color: '#e5e7eb',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 1280 }}>
        {/* Top Center Logo */}
<Box
  sx={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    mb: 4,
  }}
>
<Box
  sx={{
    p: 2.5,
    borderRadius: 3,
    bgcolor: '#ffffff',                 // 👈 white background
    border: '1px solid rgba(0,0,0,0.08)', // subtle light border
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
  }}
>
  <img
    src={logo2}
    alt="LeadFeed"
    style={{
      height: 70,
      display: 'block',
    }}
  />
</Box>
</Box>
        {/* Header */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            px: 3,
            py: 2.5,
            borderRadius: 3,
            bgcolor: 'rgba(15,23,42,0.9)',
            border: '1px solid rgba(148,163,184,0.35)',
            boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
            backdropFilter: 'blur(18px)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  p: 1,
                  borderRadius: 2,
                  bgcolor: '#ffffff', 
                  border: '1px solid rgba(148,163,184,0.5)',
                  boxShadow: '0 0 30px rgba(34,197,94,0.25)',
                }}
              >
                <img
                  src={logo2}
                  alt="LeadFeed"
                  style={{ height: 40, display: 'block' }}
                />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  fontWeight={800}
                  sx={{
                    letterSpacing: 0.3,
                    textTransform: 'uppercase',
                    color: '#f9fafb',
                  }}
                >
                  LeadFeed dashboard
                </Typography>
                <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
  }}
>
  <Box>
    {/* <Typography
      variant="h4"
      sx={{ fontWeight: 700, color: '#f9fafb', letterSpacing: 0.5 }}
    >
      Your Property Guys
    </Typography> */}
    <Typography
      variant="body2"
      sx={{ color: '#9ca3af', mt: 0.5 }}
    >
      Live Leads · DM autopilot
    </Typography>
  </Box>

  
  {/* <ToggleButtonGroup
    size="small"
    exclusive
    value={selectedMarket}
    onChange={(_, val) => {
      if (val) setSelectedMarket(val);
    }}
    sx={{
      backgroundColor: '#020617',
      borderRadius: '999px',
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        fontSize: 13,
        px: 2.5,
        py: 0.5,
        color: '#e5e7eb',
        border: 'none',
        '&.Mui-selected': {
          backgroundColor: '#22c55e',
          color: '#020617',
        },
      },
    }}
  >
    <ToggleButton value="Memphis">Memphis</ToggleButton>
    <ToggleButton value="Northern Virginia">NOVA</ToggleButton>
    <ToggleButton value="Houston">Houston</ToggleButton>
  </ToggleButtonGroup> */}

  
</Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {/* Pulsing live indicator */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: '#22c55e',
                    boxShadow: '0 0 15px rgba(34,197,94,0.9)',
                    animation: isLiveLoading
                      ? 'pulseDot 1.4s ease-in-out infinite'
                      : 'none',
                    '@keyframes pulseDot': {
                      '0%': { transform: 'scale(1)', opacity: 1 },
                      '50%': { transform: 'scale(1.6)', opacity: 0.5 },
                      '100%': { transform: 'scale(1)', opacity: 1 },
                    },
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{ color: '#f9fafb' }}
                >
                  {isLiveLoading ? 'Live · Updating…' : 'Live · Up to date'}
                </Typography>
              </Box>

              <Button
                variant="outlined"
                size="small"
                startIcon={<RefreshIcon />}
                onClick={fetchMetrics}
                sx={{
                  textTransform: 'none',
                  borderRadius: 9999,
                  borderColor: 'rgba(148,163,184,0.6)',
                  color: '#f9fafb',
                                    fontSize:13,

                  px: 2.5,
                  '&:hover': {
                    borderColor: '#22c55e',
                    background:
                      'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.12))',
                  },
                }}
              >
                Refresh metrics
              </Button>
              <Button
    variant={showCoverageMap ? 'contained' : 'outlined'}
    onClick={() => setShowCoverageMap((prev) => !prev)}
    sx={{
                  textTransform: 'none',
                  borderRadius: 9999,
                  borderColor: 'rgba(148,163,184,0.6)',
                  color: '#f9fafb',
                  marginLeft:-1,
                  fontSize:13,
                  px: 2.5,
                  '&:hover': {
                    borderColor: '#22c55e',
                    background:
                      'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.12))',
                  },
                }}
  >
    {showCoverageMap ? 'Back to dashboard' : 'Coverage Dash '}
  </Button>
              <Button
                variant="outlined"
                onClick={() => setHealthOpen(true)}
                sx={{
                  textTransform: 'none',
                  borderRadius: 9999,
                  borderColor: 'rgba(148,163,184,0.6)',
                  color: '#f9fafb',
                  marginLeft: -1,
                  fontSize: 13,
                  px: 2.5,
                  '&:hover': {
                    borderColor: '#22c55e',
                    background:
                      'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.12))',
                  },
                }}
              >
                Scrape Health
              </Button>

              <Button
                variant="outlined"
                onClick={() => setDmReportOpen(true)}
                sx={{
                  textTransform: 'none',
                  borderRadius: 9999,
                  borderColor: 'rgba(148,163,184,0.6)',
                  color: '#f9fafb',
                  marginLeft: 1,
                  fontSize: 13,
                  px: 2.5,
                  '&:hover': {
                    borderColor: '#38bdf8',
                    background:
                      'linear-gradient(135deg, rgba(56,189,248,0.10), rgba(59,130,246,0.14))',
                  },
                }}
              >
                DM Report
              </Button>
            </Box>
            <ScrapeHealthModal open={healthOpen} onClose={() => setHealthOpen(false)} />

            {/* Weekly DM report — who was messaged, for the client summary */}
            <Dialog
              open={dmReportOpen}
              onClose={() => setDmReportOpen(false)}
              maxWidth="xl"
              fullWidth
              PaperProps={{ sx: { bgcolor: '#0b1220', color: '#f9fafb', backgroundImage: 'none' } }}
            >
              <DialogTitle sx={{ borderBottom: '1px solid rgba(148,163,184,0.2)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                  <Box>
                    <Typography sx={{ fontWeight: 800, fontSize: 18 }}>Weekly DM Report</Typography>
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                      {dmReportWeek.format('MMM D')} – {dmReportWeek.add(6, 'day').format('MMM D, YYYY')}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto', flexWrap: 'wrap' }}>
                    <Button size="small" onClick={() => setDmReportWeek(dmReportWeek.subtract(7, 'day'))}
                      sx={{ color: '#cbd5e1', textTransform: 'none' }}>← Prev week</Button>
                    <Button size="small" onClick={() => setDmReportWeek(dayjs().startOf('week'))}
                      sx={{ color: '#cbd5e1', textTransform: 'none' }}>This week</Button>
                    <Button size="small" onClick={() => setDmReportWeek(dmReportWeek.add(7, 'day'))}
                      sx={{ color: '#cbd5e1', textTransform: 'none' }}>Next week →</Button>

                    <Chip
                      size="small"
                      onClick={() => setDmReportAllMarkets(!dmReportAllMarkets)}
                      label={dmReportAllMarkets ? 'All markets' : normalizeMarket(selectedMarket)}
                      sx={{
                        cursor: 'pointer', fontWeight: 700,
                        bgcolor: dmReportAllMarkets ? 'rgba(56,189,248,0.18)' : 'rgba(34,197,94,0.18)',
                        color: dmReportAllMarkets ? '#7dd3fc' : '#86efac',
                        border: `1px solid ${dmReportAllMarkets ? 'rgba(56,189,248,0.5)' : 'rgba(34,197,94,0.5)'}`,
                      }}
                    />
                    <Button
                      size="small" variant="contained" onClick={downloadDmReportCsv}
                      disabled={!dmReportVisible.length}
                      sx={{ textTransform: 'none', bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}
                    >
                      Export CSV
                    </Button>
                  </Box>
                </Box>
              </DialogTitle>

              <DialogContent sx={{ p: 0 }}>
                {dmReportLoading && (
                  <Typography sx={{ p: 3, color: '#94a3b8' }}>Loading…</Typography>
                )}
                {!!dmReportError && (
                  <Typography sx={{ p: 3, color: '#fca5a5' }}>{dmReportError}</Typography>
                )}
                {!dmReportLoading && !dmReportError && !dmReportVisible.length && (
                  <Typography sx={{ p: 3, color: '#94a3b8' }}>
                    No DMs recorded for this week{dmReportAllMarkets ? '' : ` in ${normalizeMarket(selectedMarket)}`}.
                  </Typography>
                )}

                {/* market x day heatmap — sequential single hue, count printed in
                    every cell so identity is never carried by colour alone */}
                {!dmReportLoading && !dmReportError && (
                  <Box sx={{ px: 3, pt: 2.5, pb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 700, letterSpacing: '.08em', display: 'block' }}>
                          DMs BY MARKET AND DAY
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#64748b', fontSize: 11 }}>
                          Michael &amp; Son zones · {dmReportMatrix.grand} DM{dmReportMatrix.grand === 1 ? '' : 's'} this week
                        </Typography>
                      </Box>
                      {/* ramp legend — the cells also print their count, so colour
                          is a second read, never the only one */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontSize: 10 }}>fewer</Typography>
                        {['rgba(148,163,184,0.06)', '#14532d', '#166534', '#15803d', '#22c55e'].map((c, i) => (
                          <Box key={c} sx={{
                            width: 16, height: 10, borderRadius: '2px', bgcolor: c,
                            border: i === 0 ? '1px solid rgba(148,163,184,0.10)' : 'none',
                          }} />
                        ))}
                        <Typography variant="caption" sx={{ color: '#64748b', fontSize: 10 }}>
                          more (peak {dmReportMatrix.peak})
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ overflowX: 'auto', mt: 1.5 }}>
                      <Box sx={{ minWidth: 660 }}>
                        {/* header row */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '2px', mb: '2px' }}>
                          <Box sx={{ width: 132, flexShrink: 0 }} />
                          {dmReportMatrix.days.map((d) => (
                            <Box key={d.format('YYYY-MM-DD')} sx={{ flex: 1, textAlign: 'center', pb: 0.5 }}>
                              <Typography variant="caption" sx={{ color: '#cbd5e1', fontWeight: 700, display: 'block', lineHeight: 1.2 }}>
                                {d.format('ddd')}
                              </Typography>
                              <Typography variant="caption" sx={{ color: '#64748b', fontSize: 10 }}>
                                {d.format('M/D')}
                              </Typography>
                            </Box>
                          ))}
                          <Box sx={{ width: 54, flexShrink: 0, textAlign: 'center', pb: 0.5 }}>
                            <Typography variant="caption" sx={{ color: '#cbd5e1', fontWeight: 700 }}>Total</Typography>
                          </Box>
                        </Box>

                        {dmReportMatrix.rows.map((row) => (
                          <Box key={row.key} sx={{ display: 'flex', alignItems: 'stretch', gap: '2px', mb: '2px' }}>
                            <Box sx={{ width: 132, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                              <Typography variant="caption" sx={{ color: row.total ? '#e5e7eb' : '#64748b', fontWeight: 600 }}>
                                {row.label}
                              </Typography>
                            </Box>
                            {row.counts.map((c, i) => {
                              // sequential ramp: 0 is an empty outline, not a colour
                              const t = c / dmReportMatrix.peak;
                              const bg = c === 0
                                ? 'rgba(148,163,184,0.06)'
                                : t <= 0.25 ? '#14532d'
                                : t <= 0.5  ? '#166534'
                                : t <= 0.75 ? '#15803d'
                                : '#22c55e';
                              return (
                                <Box
                                  key={i}
                                  title={`${row.label} · ${dmReportMatrix.days[i].format('ddd MMM D')} · ${c} DM${c === 1 ? '' : 's'}`}
                                  sx={{
                                    flex: 1, height: 30, borderRadius: '4px',
                                    bgcolor: bg,
                                    border: c === 0 ? '1px solid rgba(148,163,184,0.10)' : 'none',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    cursor: 'default',
                                    '&:hover': { outline: '2px solid rgba(56,189,248,0.8)', outlineOffset: '-2px' },
                                  }}
                                >
                                  <Typography variant="caption" sx={{
                                    fontWeight: 800,
                                    color: c === 0 ? '#475569' : t > 0.75 ? '#052e16' : '#dcfce7',
                                  }}>
                                    {c || ''}
                                  </Typography>
                                </Box>
                              );
                            })}
                            <Box sx={{
                              width: 54, flexShrink: 0, height: 30, borderRadius: '4px',
                              bgcolor: 'rgba(148,163,184,0.12)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                              <Typography variant="caption" sx={{ fontWeight: 800, color: row.total ? '#ffffff' : '#475569' }}>
                                {row.total}
                              </Typography>
                            </Box>
                          </Box>
                        ))}

                        {/* per-day totals */}
                        <Box sx={{ display: 'flex', gap: '2px', mt: '4px', pt: '4px', borderTop: '1px solid rgba(148,163,184,0.18)' }}>
                          <Box sx={{ width: 132, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800 }}>All markets</Typography>
                          </Box>
                          {dmReportMatrix.dayTotals.map((t, i) => (
                            <Box key={i} sx={{ flex: 1, textAlign: 'center' }}>
                              <Typography variant="caption" sx={{ fontWeight: 800, color: t ? '#7dd3fc' : '#475569' }}>{t}</Typography>
                            </Box>
                          ))}
                          <Box sx={{ width: 54, flexShrink: 0, textAlign: 'center' }}>
                            <Typography variant="caption" sx={{ fontWeight: 800, color: '#ffffff' }}>{dmReportMatrix.grand}</Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}

                {!dmReportLoading && !!dmReportVisible.length && (
                  <>
                    <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, borderBottom: '1px solid rgba(148,163,184,0.15)' }}>
                      <Typography variant="body2" sx={{ color: '#e5e7eb' }}>
                        <b>{dmReportVisible.length}</b> people DMed
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                        {new Set(dmReportVisible.map((r) => r.market)).size} markets ·{' '}
                        {new Set(dmReportVisible.map((r) => r.dmedBy).filter(Boolean)).size} accounts
                      </Typography>
                    </Box>

                    <Box sx={{ maxHeight: '62vh', overflowY: 'auto' }}>
                      {Object.entries(
                        dmReportVisible.reduce((acc, r) => {
                          (acc[r.day] = acc[r.day] || []).push(r); return acc;
                        }, {})
                      ).map(([day, rows]) => (
                        <Box key={day}>
                          <Box sx={{
                            px: 3, py: 1, bgcolor: 'rgba(30,41,59,0.9)',
                            position: 'sticky', top: 0, zIndex: 1,
                            borderBottom: '1px solid rgba(148,163,184,0.15)',
                          }}>
                            <Typography variant="caption" sx={{ color: '#7dd3fc', fontWeight: 800, letterSpacing: '.06em' }}>
                              {day.toUpperCase()} · {rows.length}
                            </Typography>
                          </Box>
                          {rows.map((r) => (
                            <Box key={r.id} sx={{
                              px: 3, py: 1.5,
                              borderBottom: '1px solid rgba(148,163,184,0.10)',
                              '&:hover': { bgcolor: 'rgba(148,163,184,0.06)' },
                            }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Typography sx={{ fontWeight: 700, color: '#ffffff' }}>{r.name}</Typography>
                                {r.neighborhood && (
                                  <Typography variant="caption" sx={{ color: '#cbd5e1' }}>· {r.neighborhood}</Typography>
                                )}
                                <Chip size="small" label={r.market}
                                  sx={{ height: 20, fontSize: 11, bgcolor: 'rgba(56,189,248,0.16)', color: '#7dd3fc' }} />
                                {r.service && (
                                  <Chip size="small" label={r.service}
                                    sx={{ height: 20, fontSize: 11, bgcolor: 'rgba(148,163,184,0.15)', color: '#e5e7eb' }} />
                                )}
                                {r.phone && (
                                  <Chip size="small" label={`☎ ${r.phone}`}
                                    sx={{ height: 20, fontSize: 11, bgcolor: 'rgba(250,204,21,0.16)', color: '#fde68a' }} />
                                )}
                                <Typography variant="caption" sx={{ color: '#94a3b8', ml: 'auto' }}>
                                  {r.time}{r.dmedBy ? ` · ${r.dmedBy}` : ''}
                                </Typography>
                              </Box>
                              {r.request && (
                                <Typography variant="body2" sx={{ color: '#cbd5e1', mt: 0.5, lineHeight: 1.5 }}>
                                  {r.request.slice(0, 190)}{r.request.length > 190 ? '…' : ''}
                                </Typography>
                              )}
                              {r.postUrl && (
                                <Typography component="a" href={r.postUrl} target="_blank" rel="noreferrer"
                                  variant="caption" sx={{ color: '#38bdf8', textDecoration: 'none', fontWeight: 700 }}>
                                  OPEN POST ↗
                                </Typography>
                              )}
                            </Box>
                          ))}
                        </Box>
                      ))}
                    </Box>
                  </>
                )}
              </DialogContent>
            </Dialog>
<MarketMap
    value={selectedMarket}
    onChange={(m) => {
      setSelectedMarket(m);
      setDmModalMarket(m); // keep DM modal in sync
    }}
    height={600}
    width= {1200}
  />
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <Paper
    elevation={0}
    sx={{
      mb: 2,
      px: 2.5,
      py: 2,
      borderRadius: 3,
      backgroundColor: '#f8fafc',
      boxShadow: '0 6px 20px rgba(0,0,0,0.06)',

      // ✅ actually center the whole bar on the page
      maxWidth: 1310,
      mx: 'auto',
    }}
  >
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
  {/* ✅ BIG market map ABOVE */}
  

  {/* ✅ Date + controls bar BELOW */}
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      '& > *': { flexShrink: 0 },
    }}
  >
    {/* Date mode toggle */}
    <ToggleButtonGroup
      exclusive
      value={dateMode}
      onChange={(_, val) => val && setDateMode(val)}
      sx={{
        background: '#fff',
        borderRadius: 999,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
        '& .MuiToggleButton-root': {
          border: 0,
          borderRadius: 999,
          px: 2,
          py: 0.75,
          fontSize: 13,
          fontWeight: 600,
          color: '#475569',
          textTransform: 'none',
        },
        '& .Mui-selected': {
          backgroundColor: '#334155',
          color: '#fff',
        },
      }}
    >
      <ToggleButton value="single">One date</ToggleButton>
      <ToggleButton value="range">Range</ToggleButton>
    </ToggleButtonGroup>

    {/* Date picker(s) */}
    {dateMode === 'single' ? (
      <DatePicker
        label="Date"
        value={singleDate}
        onChange={(v) => v && setSingleDate(v)}
        slotProps={{
          textField: {
            size: 'small',
            sx: { minWidth: 160, backgroundColor: '#fff', borderRadius: 2 },
          },
        }}
      />
    ) : (
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
        <DatePicker
          label="From"
          value={rangeStart}
          onChange={(v) => v && setRangeStart(v)}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150, backgroundColor: '#fff', borderRadius: 2 },
            },
          }}
        />
        <DatePicker
          label="To"
          value={rangeEnd}
          onChange={(v) => v && setRangeEnd(v)}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150, backgroundColor: '#fff', borderRadius: 2 },
            },
          }}
        />
      </Box>
    )}

    <Chip
      label={label}
      sx={{
        backgroundColor: '#e2e8f0',
        color: '#334155',
        fontWeight: 700,
        borderRadius: 2,
      }}
    />

<Button
  variant="contained"
  onClick={() => {
    console.log('DM Calendar clicked');
    setDmMonth(dayjs());

    setDmSelectedDay(dayjs());
    setDmModalMarket(selectedMarket);
    setDmCalendarOpen(true);
  }}
>
  DM Calendar
</Button>
  </Box>
</Box>
  </Paper>
</LocalizationProvider>
          </Box>
          
                  </Paper>

        {showCoverageMap && (
          <Box sx={{ mt: 3 }}>
            <CoverageMap />
          </Box>
        )}

 {!showCoverageMap && (
          <React.Fragment>
            {/* GHL Inbound row (per selected market) */}
            
        {/* Metrics row */}
        {/* the actual leads behind whichever stat box is open */}
        {openStat && (() => {
          const src = openStat === 'day' ? todayLeads : aiGoodLeads;
          const title = openStat === 'day'
            ? `All leads identified · ${statDateLabel}`
            : `AI verified good · ${statDateLabel}`;
          const accent = openStat === 'day' ? '#22c55e' : '#38bdf8';
          const when = (l) => {
            const d = l.createdAt?.toDate?.() || (l.createdAt?.seconds ? new Date(l.createdAt.seconds * 1000) : null);
            return d ? d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '';
          };
          const sorted = [...src].sort((a, b) => {
            const av = a.createdAt?.toMillis?.() ?? a.createdAt?.seconds ?? 0;
            const bv = b.createdAt?.toMillis?.() ?? b.createdAt?.seconds ?? 0;
            return bv - av;
          });
          return (
            <Box sx={{ mb: 3, borderRadius: 3, bgcolor: 'rgba(15,23,42,0.9)', border: `1px solid ${accent}55`, overflow: 'hidden' }}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', px: 2, py: 1.5, borderBottom: '1px solid rgba(148,163,184,0.15)' }}>
                <Typography variant="subtitle2" sx={{ color: '#f9fafb', fontWeight: 700 }}>{title}</Typography>
                <Typography variant="caption" sx={{ color: accent, fontWeight: 700 }}>
                  {src.length} leads · {selectedMarket}
                </Typography>
              </Box>
              <Box sx={{ maxHeight: 460, overflowY: 'auto' }}>
                {!sorted.length && (
                  <Typography variant="body2" sx={{ color: '#94a3b8', p: 2 }}>No leads in this window.</Typography>
                )}
                {sorted.map((l, i) => {
                  const good = l.finalGateVerdict === 'good';
                  const url = l.permalink || l.postUrl;
                  return (
                    <Box key={l.id || i} sx={{
                      px: 2, py: 1.25,
                      borderBottom: '1px solid rgba(148,163,184,0.10)',
                      '&:hover': { bgcolor: 'rgba(148,163,184,0.06)' },
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                        <Chip
                          size="small"
                          label={l._svc || l.serviceType || 'Unknown'}
                          sx={{ height: 20, fontSize: 11, bgcolor: 'rgba(148,163,184,0.15)', color: '#e5e7eb' }}
                        />
                        {/* only meaningful in the "all identified" list, where both kinds appear */}
                        {openStat === 'day' && (
                          <Chip
                            size="small"
                            label={good ? 'AI: good' : 'AI: rejected'}
                            sx={{
                              height: 20, fontSize: 11, fontWeight: 700,
                              bgcolor: good ? 'rgba(34,197,94,0.18)' : 'rgba(239,68,68,0.18)',
                              color: good ? '#86efac' : '#fca5a5',
                              border: `1px solid ${good ? 'rgba(34,197,94,0.5)' : 'rgba(239,68,68,0.5)'}`,
                            }}
                          />
                        )}
                        <Typography variant="caption" sx={{ color: '#94a3b8', ml: 'auto' }}>{when(l)}</Typography>
                      </Box>
                      <Typography variant="body2" sx={{ color: '#e5e7eb', lineHeight: 1.5 }}>
                        {String(l.text || '—').slice(0, 220)}
                        {String(l.text || '').length > 220 ? '…' : ''}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600 }}>
                          {l.author || 'Unknown'}
                        </Typography>
                        {l.neighborhood && (
                          <Typography variant="caption" sx={{ color: '#64748b' }}>· {l.neighborhood}</Typography>
                        )}
                        {url && (
                          <Typography
                            component="a" href={url} target="_blank" rel="noreferrer"
                            variant="caption"
                            sx={{ ml: 'auto', color: accent, textDecoration: 'none', fontWeight: 700 }}
                          >
                            OPEN ↗
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          );
        })()}

        <Grid container spacing={2} sx={{ mb: 3 }}>
         <Grid item xs={12} sm={6}>

</Grid>

        
        

       <Grid container spacing={2} sx={{ mb: 3 }}>
  <Grid item xs={12} sm={6} md={3}>
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        bgcolor: 'rgba(15,23,42,0.9)',
        border: '1px solid rgba(34,197,94,0.35)',
        boxShadow: '0 15px 40px rgba(2,6,23,0.35)',
        position: 'relative',
        overflow: 'hidden',
        color: '#f9fafb',
        minHeight: 132,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, rgba(16,185,129,0.3), rgba(34,197,94,0.05))',
          pointerEvents: 'none',
        }}
      />
     <CardContent sx={{ position: 'relative' }}>
  <Typography variant="caption" sx={{ color: '#f9fafb' }}>
    Avg Response Time (8:30am–8:30pm) · {statDateLabel}
  </Typography>
  <Typography
    variant="h4"
    fontWeight={800}
    sx={{ mt: 0.5, color: '#ffffff' }}
  >
    {metricsLoading ? '—' : avgResponseTimeTodayLabel}
  </Typography>
  <Typography
    variant="body2"
    sx={{ color: '#f9fafb', mt: 0.5 }}
  >
    From captured leads closed today
  </Typography>
</CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} sm={6} md={3}>
    <Card
      elevation={0}
      onClick={() => setOpenStat(openStat === 'day' ? null : 'day')}
      sx={{
        borderRadius: 3,
        bgcolor: 'rgba(15,23,42,0.9)',
        border: '1px solid rgba(34,197,94,0.35)',
        boxShadow: '0 15px 40px rgba(2,6,23,0.35)',
        position: 'relative',
        overflow: 'hidden',
        color: '#f9fafb',
        minHeight: 132,
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, rgba(16,185,129,0.3), rgba(34,197,94,0.05))',
          pointerEvents: 'none',
        }}
      />
      <CardContent sx={{ position: 'relative' }}>
        <Typography variant="caption" sx={{ color: '#f9fafb' }}>
          {statTitle('Leads Captured')} · {statDateLabel}
        </Typography>
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{ mt: 0.5, color: '#ffffff' }}
        >
          {metricsLoading ? '—' : totalLeadsCapturedToday}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: '#f9fafb', mt: 0.5 }}
        >
          Identified Leads
        </Typography>
        <Typography variant="caption" sx={{ color: '#86efac', mt: 0.75, display: 'block' }}>
          {openStat === 'day' ? '▾ hide breakdown' : '▸ show breakdown'}
        </Typography>
      </CardContent>
    </Card>
  </Grid>

  {/* The AI's own call on the leads we captured, beside the raw count. */}
  <Grid item xs={12} sm={6} md={3}>
    <Card
      elevation={0}
      onClick={() => setOpenStat(openStat === 'ai' ? null : 'ai')}
      sx={{
        borderRadius: 3,
        bgcolor: 'rgba(15,23,42,0.9)',
        border: '1px solid rgba(56,189,248,0.35)',
        boxShadow: '0 15px 40px rgba(2,6,23,0.35)',
        position: 'relative',
        overflow: 'hidden',
        color: '#f9fafb',
        minHeight: 132,
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, rgba(56,189,248,0.28), rgba(14,165,233,0.05))',
          pointerEvents: 'none',
        }}
      />
      <CardContent sx={{ position: 'relative' }}>
        <Typography variant="caption" sx={{ color: '#f9fafb' }}>
          {statTitle('AI Verified Good')} · {statDateLabel}
        </Typography>
        <Typography variant="h4" fontWeight={800} sx={{ mt: 0.5, color: '#ffffff' }}>
          {metricsLoading ? '—' : aiGoodLeads.length}
        </Typography>
        <Typography variant="body2" sx={{ color: '#f9fafb', mt: 0.5 }}>
          {todayLeads.length
            ? `${Math.round((aiGoodLeads.length / todayLeads.length) * 100)}% of identified`
            : 'Passed the final gate'}
        </Typography>
        <Typography variant="caption" sx={{ color: '#7dd3fc', mt: 0.75, display: 'block' }}>
          {openStat === 'ai' ? '▾ hide breakdown' : '▸ show breakdown'}
        </Typography>
      </CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} sm={6} md={3}>
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        bgcolor: 'rgba(15,23,42,0.9)',
        border: '1px solid rgba(59,130,246,0.45)',
        boxShadow: '0 15px 40px rgba(59,130,246,0.25)',
        position: 'relative',
        overflow: 'hidden',
        color: '#f9fafb',
        minHeight: 132,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, rgba(59,130,246,0.25), rgba(96,165,250,0.05))',
          pointerEvents: 'none',
        }}
      />
      <CardContent sx={{ position: 'relative' }}>
        <Typography variant="caption" sx={{ color: '#f9fafb' }}>
          {statTitle('Leads DMed')} · {statDateLabel}
        </Typography>
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{ mt: 0.5, color: '#ffffff' }}
        >
          {metricsLoading ? '—' : totalLeadsDmedToday}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: '#f9fafb', mt: 0.5 }}
        >
          Ai DMed
        </Typography>
      </CardContent>
    </Card>
  </Grid>
</Grid>
          <Grid item xs={12} md={3}>
 
</Grid>
        </Grid>

        {metricsLoading && (
          <Box sx={{ mb: 2 }}>
            <LinearProgress
              sx={{
                height: 3,
                borderRadius: 9999,
                bgcolor: 'rgba(15,23,42,0.8)',
                '& .MuiLinearProgress-bar': {
                  background:
                    'linear-gradient(90deg, #22c55e, #4ade80, #22c55e)',
                },
              }}
            />
          </Box>
        )}

        {metricsError && (
          <Typography color="error" sx={{ mb: 2 }}>
            {metricsError}
          </Typography>
        )}
{/* DMs sent today (list of posts that got a DM) */}
<Box sx={{ mt: 2, mb: 2 }}>
  <Paper
    elevation={0}
    sx={{
      borderRadius: 3,
      bgcolor: 'rgba(15,23,42,0.98)',
      border: '1px solid rgba(55,65,81,0.95)',
      boxShadow: '0 18px 50px rgba(0,0,0,0.85)',
      p: 2.5,
    }}
  >
    <Typography
      variant="subtitle1"
      fontWeight={700}
      sx={{ mb: 1, letterSpacing: 0.5, color: '#ffffff' }}
    >
      DMs sent today · {marketLabelShort}
    </Typography>

    {metricsLoading ? (
      <Typography variant="body2" sx={{ color: '#f9fafb' }}>
        Loading…
      </Typography>
    ) : todayDmedLeads.length === 0 ? (
      <Typography variant="body2" sx={{ color: '#f9fafb' }}>
        No DMs sent yet today for {marketLabelShort}.
      </Typography>
    ) : (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
          maxHeight: 380,
          overflowY: 'auto',
        }}
      >
        {todayDmedLeads.map(({ lead, dm, createdAt, svc }, idx) => {
          const postedLabel =
            lead.timeLabel ||
            (createdAt
              ? createdAt.toLocaleString(undefined, {
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                })
              : null);

          const avatarSrc =
            lead.avatar ||
            (Array.isArray(lead.images) && lead.images.length
              ? lead.images[0]
              : null);

          const initials =
            (lead.author || '')
              .split(' ')
              .filter(Boolean)
              .map((p) => p[0])
              .join('')
              .slice(0, 2) || '?';

              
const Icon = SERVICE_ICONS[svc] || DeviceUnknownIcon;
const wouldHaveBeenDmed = !!lead.wouldHaveBeenDmed;
const phone = extractPhoneNumber(lead.text || '');          
const leadValueMeta = getLeadValueMeta(lead, dm);
const hasDm = !!lead.manualDmed;
          return (
            <Box key={`${lead.id}-${dm.id}`}>
              {idx > 0 && (
                <Divider
                  sx={{
                    my: 1,
                    borderColor: 'rgba(31,41,55,1)',
                  }}
                />
              )}

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  py: 1,
                }}
              >
                <Avatar
                  src={avatarSrc || undefined}
                  alt={lead.author || 'Lead'}
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: avatarSrc
                      ? '#111827'
                      : 'rgba(16,185,129,0.9)',
                    fontSize: 14,
                    fontWeight: 600,
                    border: '1px solid rgba(31,41,55,1)',
                  }}
                >
                  {!avatarSrc ? initials : null}
                </Avatar>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {/* Header row */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      mb: 0.5,
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        noWrap
                        sx={{ color: '#ffffff' }}
                      >
                        {lead.author || 'Unknown'}
                      </Typography>
                      {postedLabel && (
                        <Typography
                          variant="caption"
                          sx={{ color: '#f9fafb' }}
                        >
                          {postedLabel}
                        </Typography>
                      )}
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flexShrink: 0,
                      }}
                    >
                      {/* Service pill */}
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.5,
                          px: 1,
                          py: 0.3,
                          borderRadius: 9999,
                          bgcolor: 'rgba(15,23,42,1)',
                          border: '1px solid rgba(55,65,81,0.95)',
                        }}
                      >
                        <Icon
                          sx={{
                            fontSize: 16,
                            color: '#22c55e',
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            color: '#ffffff',
                            fontWeight: 500,
                          }}
                        >
                          {svc}
                        </Typography>

                        {phone && (
  <div
    style={{
      backgroundColor: '#FFD54F',
      color: '#000',
      padding: '4px 10px',
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      marginLeft: 8,
      display: 'inline-block',
    }}
  >
    {phone}
  </div>

  
)}



                      </Box>

                      {/* AI lead value tag (optional) */}
                      {leadValueMeta && (
                        <Tooltip title={leadValueMeta.tooltip}>
                          <Chip
                            size="small"
                            label={leadValueMeta.label}
                            sx={{
                              borderRadius: 9999,
                              bgcolor: 'rgba(22,163,74,0.16)',
                              border: '1px solid rgba(34,197,94,0.65)',
                              color: '#bbf7d0',
                              fontWeight: 600,
                            }}
                          />
                        </Tooltip>
                      )}

                      {/* DM icon */}
                      <Tooltip title="DM sent">
                        <SmsIcon
                          sx={{
                            fontSize: 18,
                            color: '#60a5fa',
                          }}
                        />
                      </Tooltip>

                      <Tooltip
  title={
    hasDm ? 'DM sent' : 'No DM recorded for this lead'
  }
>
  <SmsIcon
    sx={{
      fontSize: 18,
      color: hasDm ? '#60a5fa' : '#6b7280',
    }}
  />
</Tooltip>

{/* Manual DM status */}
{lead.manualDmed && (
  <Chip
    size="small"
    label={`DMed via ${lead.manualDmedAccount || 'Manual'}`}
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(59,130,246,0.14)',
      border: '1px solid rgba(59,130,246,0.45)',
      color: '#bfdbfe',
      fontWeight: 700,
    }}
  />
)}

{/* Manual DM button */}
{lead.wouldHaveBeenDmed && !lead.manualDmed && (
  <Button
    size="small"
    variant="contained"
    onClick={() => handleOpenMarkDmedModal(lead)}
    sx={{
      borderRadius: 9999,
      textTransform: 'none',
      fontWeight: 700,
      px: 1.5,
      py: 0.5,
      ml: 0.5,
    }}
  >
    Mark as DMed
  </Button>
)}
                    </Box>
                  </Box>

                  {/* Original post text */}
                  {lead.text && (
                    <Typography
                      variant="body2"
                      sx={{
                        mb: 0.5,
                        whiteSpace: 'pre-line',
                        color: '#e5e7eb',
                      }}
                    >
                      {lead.text}
                    </Typography>
                  )}

                  {/* DM preview */}
                  {dm.dmText && (
                    <Box
                      sx={{
                        mt: 0.5,
                        p: 1,
                        borderRadius: 2,
                        bgcolor: 'rgba(15,23,42,1)',
                        border: '1px solid rgba(96,165,250,0.6)',
                        boxShadow: '0 0 25px rgba(37,99,235,0.35)',
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          mb: 0.25,
                          color: '#bfdbfe',
                        }}
                      >
                        DM sent:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 12,
                          whiteSpace: 'pre-line',
                          color: '#dbeafe',
                        }}
                      >
                        {dm.dmText}
                      </Typography>
                    </Box>
                  )}

                  {/* Permalink + copy link */}
                  {lead.permalink && (
                    <Box
                      sx={{
                        mt: 0.6,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                      }}
                    >
                      <Typography variant="caption">
                        <a
                          href={lead.permalink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#60a5fa' }}
                        >
                          View post
                        </a>
                      </Typography>

                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleCopyLink(lead.permalink)}
                        sx={{
                          textTransform: 'none',
                          borderRadius: 9999,
                          color: '#bfdbfe',
                          borderColor: 'rgba(96,165,250,0.7)',
                          padding: '2px 10px',
                          fontSize: '11px',
                          minWidth: 'auto',
                          background: 'rgba(30,58,138,0.25)',
                          boxShadow: '0 0 12px rgba(59,130,246,0.45)',
                          backdropFilter: 'blur(4px)',
                          '&:hover': {
                            borderColor: '#3b82f6',
                            background:
                              'linear-gradient(135deg, rgba(59,130,246,0.35), rgba(30,58,138,0.25))',
                            boxShadow: '0 0 18px rgba(59,130,246,0.75)',
                            transform: 'translateY(-1px)',
                          },
                        }}
                        startIcon={
                          <ContentCopyIcon
                            sx={{
                              fontSize: 13,
                              color: '#93c5fd',
                            }}
                          />
                        }
                      >
                        Copy link
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    )}
  </Paper>
</Box>
        {/* Leads by service type */}
        <Box sx={{ mb: 2, mt: 1 }}>
            
          <Typography
            variant="subtitle1"
            fontWeight={700}
            sx={{ mb: 1, letterSpacing: 0.5, color: '#ffffff' }}
          >
            Lead mix Today · by service
          </Typography>
                    <Grid container spacing={1.5}>
            {SERVICE_LABELS.map((svc) => {
              const count = serviceCountsToday[svc] || 0;
              const Icon = SERVICE_ICONS[svc] || DeviceUnknownIcon;

              const hasLeads = count > 0;
              const isSelected = selectedService === svc;

              return (
                <Grid item xs={12} sm={6} md={3} key={svc}>
                  <Card
                    elevation={0}
                    onClick={() =>
                      setSelectedService((prev) =>
                        prev === svc ? null : svc
                      )
                    }
                    sx={{
                      borderRadius: 3,
                      bgcolor: 'rgba(15,23,42,0.95)',
                      border:
                        hasLeads || isSelected
                          ? '1px solid rgba(16,185,129,0.9)'
                          : '1px solid rgba(55,65,81,0.9)',
                      boxShadow: isSelected
                        ? '0 0 0 1px rgba(34,197,94,0.6), 0 12px 30px rgba(0,0,0,0.9)'
                        : '0 12px 30px rgba(0,0,0,0.8)',
                      color: '#f9fafb',
                      cursor: 'pointer',
                      transition: 'transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow:
                          '0 0 0 1px rgba(34,197,94,0.4), 0 14px 34px rgba(0,0,0,0.95)',
                      },
                    }}
                  >
                    <CardContent
                      sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
                    >
                      <Box
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: 'rgba(31,41,55,0.9)',
                          border: '1px solid rgba(75,85,99,0.9)',
                        }}
                      >
                        <Icon sx={{ fontSize: 22, color: '#22c55e' }} />
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: '#ffffff' }}
                        >
                          {svc}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight={800}
                          sx={{ lineHeight: 1.1, color: '#ffffff' }}
                        >
                          {metricsLoading ? '—' : count}
                        </Typography>
                        {/* removed "Nextdoor homeowner requests" line to make tiles shorter */}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          {serviceCountsToday['Other/Unclear'] > 0 && (
            <Box sx={{ mt: 1 }}>
              <Tooltip title="Posts clearly asking for help but with vague service type">
                <Typography
                  variant="caption"
                  sx={{ color: '#f9fafb' }}
                >
                  Other/Unclear today: {serviceCountsToday['Other/Unclear']}
                </Typography>
              </Tooltip>
            </Box>
          )}
        </Box>
                {/* Selected service leads */}
                {/* Selected service leads */}
        {selectedService && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                bgcolor: 'rgba(15,23,42,0.98)',
                border: '1px solid rgba(55,65,81,0.95)',
                boxShadow: '0 18px 50px rgba(0,0,0,0.85)',
                p: 2.5,
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{ mb: 1, letterSpacing: 0.5, color: '#ffffff' }}
              >
                Today&apos;s {selectedService} leads
              </Typography>

              {selectedServiceLeads.length === 0 ? (
                <Typography
                  variant="body2"
                  sx={{ color: '#f9fafb' }}
                >
                  No {selectedService.toLowerCase()} leads found for today.
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0,
                    maxHeight: 380,
                    overflowY: 'auto',
                  }}
                >
                  {selectedServiceLeads.map((lead, idx) => {
                    const svc =
                      lead._svc ||
                      normalizeSvc(lead.serviceType || lead.classification);

                    const postedAt =
                      lead.postedAt && tsToDate(lead.postedAt)
                        ? tsToDate(lead.postedAt)
                        : tsToDate(lead.createdAt);

                    const postedLabel =
                      lead.timeLabel ||
                      (postedAt
                        ? postedAt.toLocaleString(undefined, {
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: '2-digit',
                          })
                        : null);

                    const avatarSrc =
                      lead.avatar ||
                      (Array.isArray(lead.images) && lead.images.length
                        ? lead.images[0]
                        : null);

                    const initials =
                      (lead.author || '')
                        .split(' ')
                        .filter(Boolean)
                        .map((p) => p[0])
                        .join('')
                        .slice(0, 2) || '?';

                    const Icon = SERVICE_ICONS[svc] || DeviceUnknownIcon;
   
                    
                    const wouldHaveBeenDmed = !!lead.wouldHaveBeenDmed;
const wouldHaveBeenDmedReason = lead.wouldHaveBeenDmedReason || null;
const hasDm = !!lead.wouldHaveBeenDmed;
const dm = null;

const verdictGood =
  String(lead.verdict || '').toLowerCase() === 'good';
const leadValueMeta = getLeadValueMeta(lead, null);
const phone = extractPhoneNumber(lead.text || '');
                    return (
                      <Box key={lead.id}>
                        {idx > 0 && (
                          <Divider
                            sx={{
                              my: 1,
                              borderColor: 'rgba(31,41,55,1)',
                            }}
                          />
                        )}
<Box

sx={{
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    py: 1,
    px: lead.isBadLead || phone || wouldHaveBeenDmed ? 1.25 : 0,
    borderRadius: lead.isBadLead || phone || wouldHaveBeenDmed ? 2 : 0,
    border: lead.isBadLead
      ? '1px solid rgba(239,68,68,0.9)'
      : phone
      ? '1px solid rgba(250,204,21,0.95)'
      : wouldHaveBeenDmed
      ? '1px solid rgba(16,185,129,0.85)'
      : '1px solid transparent',
    bgcolor: lead.isBadLead
      ? 'rgba(127,29,29,0.35)'
      : phone
      ? 'rgba(250,204,21,0.18)'
      : wouldHaveBeenDmed
      ? 'rgba(6,78,59,0.35)'
      : 'transparent',
    cursor: 'pointer',
    transition: 'all 0.18s ease',
    '&:hover': {
      bgcolor: lead.isBadLead
        ? 'rgba(127,29,29,0.45)'
        : phone
        ? 'rgba(250,204,21,0.24)'
        : wouldHaveBeenDmed
        ? 'rgba(6,78,59,0.45)'
        : 'rgba(30,41,59,0.55)',
      transform: 'translateY(-1px)',
    },
  }}
>
                          <Avatar
                            src={avatarSrc || undefined}
                            alt={lead.author || 'Lead'}
                            sx={{
                              width: 40,
                              height: 40,
                              bgcolor: avatarSrc
                                ? '#111827'
                                : 'rgba(16,185,129,0.9)',
                              fontSize: 14,
                              fontWeight: 600,
                              border: '1px solid rgba(31,41,55,1)',
                            }}
                          >
                            {!avatarSrc ? initials : null}
                          </Avatar>

                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            {/* Header row */}
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 1,
                                mb: 0.5,
                              }}
                            >
                              <Box sx={{ minWidth: 0 }}>
                                <Typography
                                  variant="body2"
                                  fontWeight={600}
                                  noWrap
                                  sx={{ color: '#ffffff' }}
                                >
                                  {lead.author || 'Unknown'}
                                </Typography>
                                {postedLabel && (
                                  <Typography
                                    variant="caption"
                                    sx={{ color: '#f9fafb' }}
                                  >
                                    {postedLabel}
                                  </Typography>
                                )}
                              </Box>

                              <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
  }}
>
  {/* Service pill */}
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1,
      py: 0.3,
      borderRadius: 9999,
      bgcolor: 'rgba(15,23,42,1)',
      border: '1px solid rgba(55,65,81,0.95)',
    }}
  >
    <Icon
      sx={{
        fontSize: 16,
        color: '#22c55e',
      }}
    />
    <Typography
      variant="caption"
      sx={{
        color: '#ffffff',
        fontWeight: 500,
      }}
    >
      {svc}
    </Typography>
  </Box>
{lead.isBadLead && (
  <Chip
    size="small"
    label="Bad Lead / Small Job"
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(239,68,68,0.14)',
      border: '1px solid rgba(239,68,68,0.45)',
      color: '#fecaca',
      fontWeight: 700,
    }}
  />
)}
  {phone && (
  <Chip
    size="small"
    label={phone}
    sx={{
      borderRadius: 9999,
      bgcolor: '#facc15',
      border: '1px solid rgba(250,204,21,0.95)',
      color: '#111827',
      fontWeight: 700,
    }}
  />
)}



{lead.wouldHaveBeenDmed && (
  <Chip
    size="small"
    label="Would Have DM’d"
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(22,163,74,0.16)',
      border: '1px solid rgba(34,197,94,0.65)',
      color: '#bbf7d0',
      fontWeight: 700,
    }}
  />
)}

{!wouldHaveBeenDmed && wouldHaveBeenDmedReason && (
  <Chip
    size="small"
    label={wouldHaveBeenDmedReason}
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(239,68,68,0.12)',
      border: '1px solid rgba(239,68,68,0.45)',
      color: '#fecaca',
      fontWeight: 700,
    }}
  />
)}
  {/* AI lead value tag (if present) */}
  {leadValueMeta && (
    <Tooltip title={leadValueMeta.tooltip}>
      <Chip
        size="small"
        label={leadValueMeta.label}
        sx={{
          borderRadius: 9999,
          bgcolor: 'rgba(22,163,74,0.16)',
          border: '1px solid rgba(34,197,94,0.65)',
          color: '#bbf7d0',
          fontWeight: 600,
        }}
      />
    </Tooltip>
  )}

  {/* Verdict icon */}
  {verdictGood && (
    <Tooltip title="AI-marked good lead">
      <CheckCircleIcon
        sx={{
          fontSize: 18,
          color: '#22c55e',
        }}
      />
    </Tooltip>
  )}

  {/* DM status */}
  <Tooltip
    title={
      hasDm ? 'DM sent' : 'No DM recorded for this lead'
    }
  >
    
    <SmsIcon
      sx={{
        fontSize: 18,
        color: hasDm ? '#60a5fa' : '#6b7280',
      }}
    />
  </Tooltip>
  {lead.manualDmed && (
  <Chip
    size="small"
    label={`DMed via ${lead.manualDmedAccount || 'Manual'}`}
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(59,130,246,0.14)',
      border: '1px solid rgba(59,130,246,0.45)',
      color: '#bfdbfe',
      fontWeight: 700,
    }}
  />
)}

{lead.manualDmed && (
  <Chip
    size="small"
    label={`DMed via ${lead.manualDmedAccount || 'Manual'}`}
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(59,130,246,0.14)',
      border: '1px solid rgba(59,130,246,0.45)',
      color: '#bfdbfe',
      fontWeight: 700,
    }}
  />
)}

{lead.wouldHaveBeenDmed && !lead.manualDmed && (
  <Button
    size="small"
    variant="contained"
    onClick={() => handleOpenMarkDmedModal(lead)}
    sx={{
      borderRadius: 9999,
      textTransform: 'none',
      fontWeight: 700,
      px: 1.5,
      py: 0.5,
      ml: 0.5,
    }}
  >
    Mark as DMed
  </Button>
)}
</Box>
                            </Box>

                            {/* Lead text */}
                            {lead.text && (
                              <Typography
                                variant="body2"
                                sx={{
                                  mb: hasDm ? 0.5 : 0,
                                  whiteSpace: 'pre-line',
                                  color: '#e5e7eb',
                                }}
                              >
                                {lead.text}
                              </Typography>
                            )}

                            {/* DM preview */}
                            {/* DM text (if exists) */}
{!!dm?.dmText && (
                              <Box
                                sx={{
                                  mt: 0.5,
                                  p: 1,
                                  borderRadius: 2,
                                  bgcolor: 'rgba(15,23,42,1)',
                                  border:
                                    '1px solid rgba(96,165,250,0.6)',
                                  boxShadow:
                                    '0 0 25px rgba(37,99,235,0.35)',
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    display: 'block',
                                    mb: 0.25,
                                    color: '#bfdbfe',
                                  }}
                                >
                                  DM preview:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: 12,
                                    whiteSpace: 'pre-line',
                                    color: '#dbeafe',
                                  }}
                                >
                                  {dm.dmText}
                                </Typography>
                              </Box>
                            )}

                            {/* Permalink */}
                            {lead.permalink && (
                              <Typography
                                variant="caption"
                                sx={{
                                  mt: 0.6,
                                  display: 'block',
                                }}
                              >
                                <a
                                  href={lead.permalink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: '#60a5fa' }}
                                >
                                  View post
                                </a>
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Paper>
          </Box>
        )}

        {/* Recent scrapes + logs */}
        <Box sx={{ mt: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'space-between',
              mb: 1.5,
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ letterSpacing: 0.5, color: '#ffffff' }}
            >
              Recent AI scrapes · last 10 runs
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: '#f9fafb' }}
            >
              Showing {scrapes.length} run
              {scrapes.length === 1 ? '' : 's'}
            </Typography>
          </Box>

          {scrapesLoading && (
            <Box sx={{ mb: 2 }}>
              <LinearProgress
                sx={{
                  height: 3,
                  borderRadius: 9999,
                  bgcolor: 'rgba(15,23,42,0.8)',
                  '& .MuiLinearProgress-bar': {
                    background:
                      'linear-gradient(90deg, #22c55e, #4ade80, #22c55e)',
                  },
                }}
              />
            </Box>
          )}

          {scrapesError && (
            <Typography color="error" sx={{ mb: 2 }}>
              {scrapesError}
            </Typography>
          )}

          {scrapes.length === 0 && !scrapesLoading ? (
            <Typography
              variant="body2"
              sx={{ color: '#f9fafb' }}
            >
              No scrapes found yet.
            </Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
{scrapes
.filter((scrape) => {
  const inferred = normalizeMarket(scrape.market || scrape.scrapeId || scrape.id || '');
  const selected = normalizeMarket(selectedMarket) || selectedMarket;

  // If we can infer the scrape’s market, enforce an exact match.
  if (inferred) return inferred === selected;

  // If we can’t infer, keep it visible (so you don’t “lose” rows).
  return true;
})
  .map((scrape) => {
  const startedAt = tsToDate(scrape.startedAt);
  const market = scrape.market || 'Unassigned';
  const source = scrape.source || 'nd50';

  const newLeadsCount =
    scrape.newLeadsCount ??
    scrape.wroteLeads ??
    scrape.total ??
    null;

  const scrapeStatus = scrape.status || null;
  const isNoLeads =
    scrapeStatus === 'no_leads' ||
    newLeadsCount === 0;

  const startedLabel = startedAt
    ? startedAt.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : 'Unknown start time';

  const leads = scrapeLeads[scrape.id] || [];
  const leadsLoading = !!scrapeLeadsLoading[scrape.id];
  const leadsError = scrapeLeadsError[scrape.id];
  const dmMap = scrapeDms[scrape.id] || {};
  const dmCount = dmMap ? Object.keys(dmMap).length : 0;
const isExpanded = !!expandedScrapes[scrape.id];

  const runState = runStates[scrape.id] || 'idle';
  const runLabel =
    runState === 'running'
      ? 'Running…'
      : runState === 'ok'
      ? 'Queued'
      : runState === 'error'
      ? 'Retry'
      : 'Run scrape';

                return (
                  <Paper
                    key={scrape.id}
                    elevation={0}
                    sx={{
                      borderRadius: 3,
                      bgcolor: 'rgba(15,23,42,0.98)',
                      border: '1px solid rgba(55,65,81,0.95)',
                      boxShadow: '0 18px 50px rgba(0,0,0,0.85)',
                      overflow: 'hidden',
                      color: '#f9fafb',
                    }}
                  >
                    {/* Scrape header */}
                    <Box
                      sx={{
                        px: 2.5,
                        py: 1.75,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        borderBottom: '1px solid rgba(31,41,55,1)',
                        background:
                          'linear-gradient(90deg, rgba(15,23,42,1), rgba(15,23,42,0.85))',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleToggleScrape(scrape)}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: 9999,
                            bgcolor: 'rgba(15,23,42,1)',
                            border: '1px solid rgba(75,85,99,0.9)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <ScheduleIcon
                            sx={{ fontSize: 18, color: '#f9fafb' }}
                          />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            variant="body2"
                            fontWeight={600}
                            sx={{ color: '#ffffff' }}
                          >
                            {startedLabel}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: '#f9fafb' }}
                          >
                            Market: {market} · Source: {source}
                          </Typography>
                        </Box>
                      </Box>

                                            <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          flexShrink: 0,
                        }}
                      >
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<PlayArrowIcon sx={{ fontSize: 16 }} />}
                          onClick={(e) => {
                            e.stopPropagation(); // don't toggle expand
                            handleRunScrape(scrape);
                          }}
                          disabled={runState === 'running'}
                          sx={{
                            textTransform: 'none',
                            borderRadius: 9999,
                            borderColor:
                              runState === 'error'
                                ? 'rgba(239,68,68,0.8)'
                                : 'rgba(148,163,184,0.7)',
                            color:
                              runState === 'error'
                                ? '#fecaca'
                                : '#f9fafb',
                            px: 1.75,
                            mr: 1,
                            '&:hover': {
                              borderColor: '#22c55e',
                              background:
                                'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.12))',
                            },
                          }}
                        >
                          {runLabel}
                        </Button>

                        <Chip
                          size="small"
                          label={
                            dmCount === 0
                              ? 'No DMs sent'
                              : `${dmCount} post${dmCount === 1 ? '' : 's'} DM\u2019d`
                          }
                          sx={{
                            borderRadius: 9999,
                            bgcolor:
                              dmCount === 0
                                ? 'rgba(31,41,55,1)'
                                : 'rgba(16,185,129,0.1)',
                            border:
                              dmCount === 0
                                ? '1px solid rgba(75,85,99,0.9)'
                                : '1px solid rgba(16,185,129,0.4)',
                            color: dmCount === 0 ? '#e5e7eb' : '#bbf7d0',
                            fontWeight: 600,
                          }}
                        />

                        <Chip
                          size="small"
                          label={`ID · ${scrape.id.slice(0, 6)}…`}
                          sx={{
                            borderRadius: 9999,
                            bgcolor: 'rgba(15,23,42,1)',
                            border: '1px solid rgba(75,85,99,0.9)',
                            color: '#f9fafb',
                          }}
                        />

                        <IconButton
                          size="small"
                          sx={{
                            ml: 0.5,
                            color: '#f9fafb',
                            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease',
                          }}
                        >
                          <ExpandMoreIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>

                    {/* Leads body (only when expanded) */}
                    {isExpanded && (
                      <Box sx={{ px: 2.5, py: 1.5 }}>
                        {leadsLoading && (
                          <Box sx={{ mb: 1.5 }}>
                            <LinearProgress
                              sx={{
                                height: 2,
                                borderRadius: 9999,
                                bgcolor: 'rgba(15,23,42,0.9)',
                                '& .MuiLinearProgress-bar': {
                                  background:
                                    'linear-gradient(90deg, #22c55e, #4ade80, #22c55e)',
                                },
                              }}
                            />
                          </Box>
                        )}

                        {leadsError && (
                          <Typography color="error" sx={{ mb: 1 }}>
                            {leadsError}
                          </Typography>
                        )}

                        {!leadsLoading && leads.length === 0 && !leadsError && (
  <Typography
    variant="body2"
    sx={{ color: '#f9fafb' }}
  >
    No new leads were captured on this run.
  </Typography>
)}

{leads.map((lead, idx) => {
const key = lead.postId || lead.permalink;
const dm = key ? dmMap[key] : null;
const hasDm = !!dm || !!lead.manualDmed;
const leadValueMeta = getLeadValueMeta(lead, dm);
const phone = extractPhoneNumber(lead.text || '');
const timerMeta = getLeadTimerMeta(lead, leadTimerNowMs);
const rawPricingDisplayValue =
  lead.pricingDisplayValue ??
  lead.jobValueHigh ??
  lead.jobValue ??
  null;

const pricingDisplayValue =
  rawPricingDisplayValue != null &&
  Number.isFinite(Number(rawPricingDisplayValue))
    ? Math.round(Number(rawPricingDisplayValue))
    : null;
const marketStr = String(lead.market || selectedMarket || '').toLowerCase();

const isValueMarket =
  marketStr.includes('houston') ||
  marketStr.includes('memphis') ||
  marketStr.includes('dallas') ||
  marketStr.includes('nashville') ||
  marketStr.includes('southfl') ||
  marketStr.includes('south fl') ||
  marketStr.includes('west palm');
const showPricingPill =
  isValueMarket && pricingDisplayValue != null;
const postedAt =
                            lead.postedAt && tsToDate(lead.postedAt)
                              ? tsToDate(lead.postedAt)
                              : null;

                          const postedLabel =
                            lead.timeLabel ||
                            (postedAt
                              ? postedAt.toLocaleString(undefined, {
                                  month: 'short',
                                  day: 'numeric',
                                  hour: 'numeric',
                                  minute: '2-digit',
                                })
                              : null);

                          const svc = normalizeSvc(
                            lead.serviceType || lead.classification
                          );

                          const avatarSrc =
                            lead.avatar ||
                            (Array.isArray(lead.images) && lead.images.length
                              ? lead.images[0]
                              : null);

                          const initials =
                            (lead.author || '')
                              .split(' ')
                              .filter(Boolean)
                              .map((p) => p[0])
                              .join('')
                              .slice(0, 2) || '?';

                          const Icon = SERVICE_ICONS[svc] || DeviceUnknownIcon;
                          const wouldHaveBeenDmed = !!lead.wouldHaveBeenDmed;

                          

const isDallas = marketStr.startsWith('dallas');

                          return (
                            <Box key={lead.id}>
                              {idx > 0 && (
                                <Divider
                                  sx={{
                                    my: 1,
                                    borderColor: 'rgba(31,41,55,1)',
                                  }}
                                />
                              )}
<Box
  
  

  sx={{
    display: 'flex',
    alignItems: 'flex-start',
    
    gap: 1.5,
    py: 1,
    px: lead.isBadLead || phone || wouldHaveBeenDmed ? 1.25 : 0,
    borderRadius: lead.isBadLead || phone || wouldHaveBeenDmed ? 2 : 0,
    border: lead.isBadLead
      ? '1px solid rgba(239,68,68,0.9)'
      : phone
      ? '1px solid rgba(250,204,21,0.95)'
      : wouldHaveBeenDmed
      ? '1px solid rgba(16,185,129,0.85)'
      : '1px solid transparent',
    bgcolor: lead.isBadLead
      ? 'rgba(127,29,29,0.35)'
      : phone
      ? 'rgba(250,204,21,0.18)'
      : wouldHaveBeenDmed
      ? 'rgba(6,78,59,0.35)'
      : 'transparent',
    cursor: 'default',
  }}
>
                                <Avatar
                                  src={avatarSrc || undefined}
                                  alt={lead.author || 'Lead'}
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    bgcolor: avatarSrc
                                      ? '#111827'
                                      : 'rgba(16,185,129,0.9)',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    border: '1px solid rgba(31,41,55,1)',
                                  }}
                                >
                                  {!avatarSrc ? initials : null}
                                </Avatar>

                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      gap: 1,
                                      mb: 0.5,
                                    }}
                                  >
                                    <Box sx={{ minWidth: 0 }}>
                                      <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        noWrap
                                        sx={{ color: '#ffffff' }}
                                      >
                                        {lead.author || 'Unknown'}
                                      </Typography>
                                      {postedLabel && (
                                        <Typography
                                          variant="caption"
                                          sx={{ color: '#f9fafb' }}
                                        >
                                          {postedLabel}
                                        </Typography>
                                      )}
                                    </Box>
                                   <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
  }}
>
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1,
      py: 0.3,
      borderRadius: 9999,
      bgcolor: 'rgba(15,23,42,1)',
      border:
        '1px solid rgba(55,65,81,0.95)',
    }}
  >
    <Icon
      sx={{
        fontSize: 16,
        color: '#22c55e',
      }}
    />
    <Typography
      variant="caption"
      sx={{
        color: '#ffffff',
        fontWeight: 500,
      }}
    >
      {svc}
    </Typography>
  </Box>

  {/* Which client owns this lead — Northern Virginia only, where both share the ground */}
  {(() => {
    const ct = clientTagFor(lead, marketStr);
    if (!ct) return null;
    return (
      <Chip
        size="small"
        label={ct.label}
        sx={{
          borderRadius: 9999,
          bgcolor: ct.bg,
          border: `1px solid ${ct.bd}`,
          color: ct.fg,
          fontWeight: 800,
          letterSpacing: '.06em',
          fontSize: 11,
        }}
      />
    );
  })()}

  {/* NEW: AI lead value tag */}
  {leadValueMeta && (
    <Tooltip title={leadValueMeta.tooltip}>
      <Chip
        size="small"
        label={leadValueMeta.label}
        sx={{
          borderRadius: 9999,
          bgcolor: 'rgba(22,163,74,0.16)',
          border: '1px solid rgba(34,197,94,0.65)',
          color: '#bbf7d0',
          fontWeight: 600,
        }}
      />
    </Tooltip>
  )}

  {String(
    lead.verdict || ''
  ).toLowerCase() === 'good' && (
    <Tooltip title="AI-marked good lead">
      <CheckCircleIcon
        sx={{
          fontSize: 18,
          color: '#22c55e',
        }}
      />
    </Tooltip>
  )}

  <Tooltip
    title={
      hasDm
        ? 'DM sent'
        : 'No DM recorded for this lead'
    }
  >
    <SmsIcon
      sx={{
        fontSize: 18,
        color: hasDm
          ? '#60a5fa'
          : '#6b7280',
      }}
    />
  </Tooltip>

{lead.manualDmed && (
  <Chip
    size="small"
    label={`DMed via ${lead.manualDmedAccount || 'Manual'}`}
    sx={{
      borderRadius: 9999,
      bgcolor: 'rgba(59,130,246,0.14)',
      border: '1px solid rgba(59,130,246,0.45)',
      color: '#bfdbfe',
      fontWeight: 700,
    }}
  />
)}
{phone && (
  <Chip
    size="small"
    label={phone}
    sx={{
      borderRadius: 9999,
      bgcolor: '#facc15',
      border: '1px solid rgba(250,204,21,0.95)',
      color: '#111827',
      fontWeight: 700,
    }}
  />
)}
{showPricingPill && (
  <Chip
    size="small"
    label={`$${pricingDisplayValue.toLocaleString()}`}
    sx={{
      borderRadius: 9999,
      bgcolor: lead.qualifiesForHoustonClient
        ? 'rgba(34,197,94,0.16)'
        : 'rgba(59,130,246,0.14)',
      border: lead.qualifiesForHoustonClient
        ? '1px solid rgba(34,197,94,0.65)'
        : '1px solid rgba(59,130,246,0.45)',
      color: lead.qualifiesForHoustonClient
        ? '#bbf7d0'
        : '#bfdbfe',
      fontWeight: 700,
    }}
  />
)}


{!lead.manualDmed && (
  <Button
    size="small"
    variant="contained"
    disabled={!!lead.isBadLead}
    onClick={(e) => {
  e.stopPropagation();
  if (lead.isBadLead) return;
  handleOpenMarkDmedModal(lead);
}}
    sx={{
      borderRadius: 9999,
      textTransform: 'none',
      fontWeight: 700,
      px: 1.5,
      py: 0.5,
      ml: 0.5,
      opacity: lead.isBadLead ? 0.55 : 1,
      pointerEvents: lead.isBadLead ? 'none' : 'auto',
    }}
  >
    Mark as DMed
  </Button>
)}
{isDallas && (
  <Button
    size="small"
    variant="contained"
    disabled={!!lead.isBadLead || !!lead.leftCommented}
    onClick={(e) => {
  e.stopPropagation();
  if (lead.isBadLead || lead.leftCommented) return;
  handleLeftComment(lead);
}}
    sx={{
      borderRadius: 9999,
      textTransform: 'none',
      fontWeight: 700,
      px: 1.5,
      py: 0.5,
      ml: 0.5,

      bgcolor: lead.leftCommented ? '#16a34a' : undefined,
      color: lead.leftCommented ? '#ffffff' : undefined,
      border: lead.leftCommented
        ? '1px solid rgba(34,197,94,1)'
        : undefined,
      boxShadow: lead.leftCommented
        ? '0 0 14px rgba(34,197,94,0.7)'
        : undefined,

      opacity: lead.isBadLead ? 0.55 : 1,
      pointerEvents: lead.isBadLead ? 'none' : 'auto',

      '&:hover': {
        bgcolor: lead.leftCommented ? '#15803d' : undefined,
      },

      // ✅ THIS FIXES YOUR ISSUE
      '&.Mui-disabled': {
        bgcolor: '#16a34a !important',
        color: '#ffffff !important',
        border: '1px solid rgba(34,197,94,1) !important',
        boxShadow: '0 0 14px rgba(34,197,94,0.7) !important',
        opacity: 1,
      },
    }}
  >
    {lead.leftCommented ? 'Commented' : 'Mark as Commented'}
  </Button>
)}

{!lead.isBadLead && (
  <Button
    size="small"
    variant="outlined"
    color="error"
    onClick={(e) => {
  e.stopPropagation();
  handleMarkBadLead(lead);
}}
    sx={{
      borderRadius: 9999,
      textTransform: 'none',
      fontWeight: 700,
      px: 1.5,
      py: 0.5,
      ml: 0.5,
    }}
  >
    Mark as Bad Lead / Small Job
  </Button>
)}
{timerMeta.label && (
  <Chip
    size="small"
    icon={
      <ScheduleIcon
        sx={{
          color: `${timerMeta.isStopped ? '#bfdbfe' : '#fef08a'} !important`,
        }}
      />
    }
    label={timerMeta.label}
    sx={{
      borderRadius: 9999,
      bgcolor: timerMeta.isStopped
        ? 'rgba(59,130,246,0.14)'
        : 'rgba(250,204,21,0.16)',
      border: timerMeta.isStopped
        ? '1px solid rgba(59,130,246,0.45)'
        : '1px solid rgba(250,204,21,0.55)',
      color: timerMeta.isStopped ? '#dbeafe' : '#fef3c7',
      fontWeight: 700,
      '& .MuiChip-label': {
        px: 0.5,
      },
    }}
  />
)}
</Box>
                                  </Box>

                                  {/* Lead text */}
                                  {lead.text && (
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        mb: hasDm ? 0.5 : 0,
                                        whiteSpace: 'pre-line',
                                        color: '#e5e7eb',
                                      }}
                                    >
                                      {lead.text}
                                    </Typography>
                                  )}

                                  {/* DM text (if exists) */}
                                 {/* DM text (if exists) */}
{!!dm?.dmText && (
  <Box
    sx={{
      mt: 0.5,
      p: 1,
      borderRadius: 2,
      bgcolor: 'rgba(15,23,42,1)',
      border:
        '1px solid rgba(96,165,250,0.6)',
      boxShadow:
        '0 0 25px rgba(37,99,235,0.35)',
    }}
  >
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mb: 0.25,
        color: '#bfdbfe',
      }}
    >
      DM preview:
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontSize: 12,
        whiteSpace: 'pre-line',
        color: '#dbeafe',
      }}
    >
      {dm.dmText}
    </Typography>
  </Box>
)}

                                  {/* Permalink */}
                              {lead.permalink && (
  <Box
    sx={{
      mt: 0.6,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
    }}
  >
    <Typography variant="caption">
      <a
        href={lead.permalink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#60a5fa' }}
      >
        View post
      </a>
    </Typography>

    <Button
  size="small"
  variant="outlined"
  onClick={() => handleCopyLink(lead.permalink)}
  sx={{
    textTransform: 'none',
    borderRadius: 9999,
    color: '#bfdbfe',
    borderColor: 'rgba(96,165,250,0.7)',
    padding: '2px 10px',
    fontSize: '11px',
    minWidth: 'auto',
    background: 'rgba(30,58,138,0.25)',
    boxShadow: '0 0 12px rgba(59,130,246,0.45)',
    backdropFilter: 'blur(4px)',
    transition:
      'all 0.18s ease, box-shadow 0.2s ease-in-out, transform 0.15s ease',
    '&:hover': {
      borderColor: '#3b82f6',
      background:
        'linear-gradient(135deg, rgba(59,130,246,0.35), rgba(30,58,138,0.25))',
      boxShadow: '0 0 18px rgba(59,130,246,0.75)',
      transform: 'translateY(-1px)',
    },
  }}
  startIcon={
    <ContentCopyIcon
      sx={{
        fontSize: 13,
        color: '#93c5fd',
      }}
    />
  }
>
  Copy link
</Button>
  </Box>
)}
                                </Box>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Paper>
                );
              })}
            </Box>
          )}
        </Box>
          </React.Fragment>
        )}
<Dialog
  open={dmCalendarOpen}
  onClose={() => setDmCalendarOpen(false)}
  fullWidth
  maxWidth="lg"
  PaperProps={{
    sx: {
      borderRadius: 4,
      overflow: 'hidden',
      bgcolor: '#f8fafc',
      boxShadow: '0 30px 80px rgba(2,6,23,0.28)',
      border: '1px solid rgba(148,163,184,0.22)',
    },
  }}
>
  <Box
    sx={{
      px: 3,
      py: 2.25,
      borderBottom: '1px solid rgba(148,163,184,0.18)',
      background:
        'linear-gradient(135deg, rgba(15,23,42,1) 0%, rgba(30,41,59,1) 100%)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      flexWrap: 'wrap',
    }}
  >
    <Box>
      <Typography sx={{ fontSize: 22, fontWeight: 900, lineHeight: 1.1 }}>
        DM Calendar
      </Typography>
      <Typography sx={{ fontSize: 13, color: 'rgba(255,255,255,0.72)', mt: 0.5 }}>
        {dmModalMarket} • Sent DM activity by day
      </Typography>
    </Box>

    <Button
      onClick={() => setDmCalendarOpen(false)}
      variant="outlined"
      sx={{
        color: '#fff',
        borderColor: 'rgba(255,255,255,0.22)',
        borderRadius: 999,
        textTransform: 'none',
        fontWeight: 700,
        '&:hover': {
          borderColor: 'rgba(255,255,255,0.38)',
          backgroundColor: 'rgba(255,255,255,0.06)',
        },
      }}
    >
      Close
    </Button>
  </Box>

  <DialogContent sx={{ p: 0 }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '430px 1fr' },
          minHeight: 640,
        }}
      >
        {/* LEFT SIDE */}
        <Box
          sx={{
            p: 3,
            borderRight: { md: '1px solid rgba(148,163,184,0.16)' },
            borderBottom: { xs: '1px solid rgba(148,163,184,0.16)', md: 'none' },
            bgcolor: '#ffffff',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
              gap: 1.5,
              mb: 2,
            }}
          >
            <Paper
              elevation={0}
              sx={{
                p: 1.6,
                borderRadius: 3,
                border: '1px solid rgba(148,163,184,0.18)',
                background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
              }}
            >
              <Typography sx={{ fontSize: 12, fontWeight: 800, color: '#64748b' }}>
                Month total
              </Typography>
              <Typography sx={{ fontSize: 24, fontWeight: 900, color: '#0f172a', mt: 0.5 }}>
                {dmMonthTotal}
              </Typography>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                p: 1.6,
                borderRadius: 3,
                border: '1px solid rgba(148,163,184,0.18)',
                background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
              }}
            >
              <Typography sx={{ fontSize: 12, fontWeight: 800, color: '#64748b' }}>
                Daily avg
              </Typography>
              <Typography sx={{ fontSize: 24, fontWeight: 900, color: '#0f172a', mt: 0.5 }}>
                {dmDailyAverageAllDays.toFixed(1)}
              </Typography>
            </Paper>
          </Box>

          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 3,
              background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
              border: '1px solid rgba(148,163,184,0.18)',
            }}
          >
            <Typography sx={{ fontSize: 13, fontWeight: 800, color: '#475569', mb: 0.5 }}>
              Selected market
            </Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 900, color: '#0f172a' }}>
              {dmModalMarket}
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#64748b', mt: 0.5 }}>
              {dmMonth.format('MMMM YYYY')}
            </Typography>
          </Box>

          <Box
            sx={{
              borderRadius: 4,
              border: '1px solid rgba(148,163,184,0.18)',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(15,23,42,0.06)',
              '& .MuiPickersCalendarHeader-root': {
                px: 2,
                pt: 1.5,
              },
              '& .MuiPickersCalendarHeader-label': {
                fontWeight: 900,
                color: '#0f172a',
                fontSize: 18,
              },
              '& .MuiDayCalendar-header': {
                px: 1,
              },
              '& .MuiDayCalendar-weekDayLabel': {
                fontWeight: 800,
                color: '#64748b',
                fontSize: 12,
              },
              '& .MuiPickersDay-root': {
                fontWeight: 800,
                color: '#0f172a',
              },
              '& .Mui-selected': {
                backgroundColor: '#0f172a !important',
                color: '#fff !important',
              },
            }}
          >
            <DateCalendar
              value={dmSelectedDay}
              onChange={(newValue) => {
                if (newValue) {
                  setDmSelectedDay(newValue);
                  setDmMonth(newValue);
                }
              }}
              onMonthChange={(newMonth) => setDmMonth(newMonth)}
              slots={{ day: DmCountDay }}
            />
          </Box>
        </Box>

        {/* RIGHT SIDE */}
        <Box
          sx={{
            p: 3,
            bgcolor: '#f8fafc',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 1.5,
              mb: 2.5,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 24, fontWeight: 900, color: '#0f172a', lineHeight: 1.1 }}>
                {dmSelectedDay.format('MMMM D, YYYY')}
              </Typography>
              <Typography sx={{ fontSize: 13, color: '#64748b', mt: 0.5 }}>
                {(dmItemsByDay[dmSelectedDay.format('YYYY-MM-DD')] || []).length} DMs sent
              </Typography>
            </Box>

            <Chip
              label={`${dmMonth.format('MMM')} avg ${dmDailyAverageAllDays.toFixed(1)}/day`}
              sx={{
                borderRadius: 999,
                fontWeight: 800,
                backgroundColor: '#e2e8f0',
                color: '#334155',
              }}
            />
          </Box>

          {(dmItemsByDay[dmSelectedDay.format('YYYY-MM-DD')] || []).length === 0 ? (
            <Paper
              elevation={0}
              sx={{
                borderRadius: 4,
                p: 4,
                textAlign: 'center',
                bgcolor: '#fff',
                border: '1px dashed rgba(148,163,184,0.35)',
              }}
            >
              <Typography sx={{ fontSize: 18, fontWeight: 900, color: '#0f172a', mb: 1 }}>
                No DMs for this day
              </Typography>
              <Typography sx={{ color: '#64748b' }}>
                Choose another date to see sent messages.
              </Typography>
            </Paper>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {(dmItemsByDay[dmSelectedDay.format('YYYY-MM-DD')] || []).map((item) => (
                <Paper
                  key={item.id}
                  elevation={0}
                  sx={{
                    p: 2,
                    borderRadius: 3,
                    bgcolor: '#fff',
                    border: '1px solid rgba(148,163,184,0.18)',
                    boxShadow: '0 8px 24px rgba(15,23,42,0.05)',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      gap: 2,
                      mb: 1,
                      flexWrap: 'wrap',
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 900, color: '#0f172a', fontSize: 16 }}>
                        {item.author || item.firstname || 'Unknown'}
                      </Typography>

                      <Typography sx={{ color: '#64748b', fontSize: 13, mt: 0.25 }}>
                        {item.serviceType || 'Unknown service'}
                      </Typography>
                    </Box>

                    <Chip
                      size="small"
                      label="DM Sent"
                      sx={{
                        borderRadius: 999,
                        fontWeight: 800,
                        backgroundColor: '#dcfce7',
                        color: '#166534',
                      }}
                    />
                  </Box>

                  {!!item.text && (
                    <Box sx={{ mb: 1.25 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 800, color: '#64748b', mb: 0.5 }}>
                        Original post
                      </Typography>
                      <Typography sx={{ color: '#334155', lineHeight: 1.55 }}>
                        {item.text}
                      </Typography>
                    </Box>
                  )}

                  {!!item.dmText && (
                    <Box
                      sx={{
                        mt: 1,
                        p: 1.5,
                        borderRadius: 2.5,
                        backgroundColor: '#eff6ff',
                        border: '1px solid rgba(96,165,250,0.22)',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, fontWeight: 800, color: '#2563eb', mb: 0.5 }}>
                        Message sent
                      </Typography>
                      <Typography sx={{ color: '#1e3a8a', lineHeight: 1.55 }}>
                        {item.dmText}
                      </Typography>
                    </Box>
                  )}

                  {!!item.permalink && (
                    <Box sx={{ mt: 1.5 }}>
                      <Button
                        size="small"
                        href={item.permalink}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          textTransform: 'none',
                          fontWeight: 800,
                          borderRadius: 999,
                        }}
                      >
                        Open post
                      </Button>
                    </Box>
                  )}
                </Paper>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </LocalizationProvider>
  </DialogContent>
</Dialog>

<Dialog
  open={markDmedOpen}
  onClose={() => {
    if (!markDmedSaving) {
      setMarkDmedOpen(false);
      setMarkDmedLead(null);
      setMarkDmedAccount('Memphis 1');
    }
  }}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle sx={{ fontWeight: 800 }}>
    Which account did you use?
  </DialogTitle>

  <DialogContent>
    <Box sx={{ pt: 1 }}>
      <FormControl fullWidth>
        <InputLabel id="manual-dm-account-label">Account</InputLabel>
        <Select
          labelId="manual-dm-account-label"
          value={markDmedAccount}
          label="Account"
          onChange={(e) => setMarkDmedAccount(e.target.value)}
        >
          {MEMPHIS_DM_ACCOUNTS.map((account) => {
  const used = manualDmCountsByAccount[account] || 0;
  const maxDMs = getMaxDMsForAccount(account);
const isDisabled = used >= maxDMs;
  return (
    <MenuItem
      key={account}
      value={account}
      disabled={isDisabled}
      sx={{
        color: isDisabled ? '#f87171' : 'inherit',
        opacity: isDisabled ? 1 : 1,
      }}
    >
      {account} ({used}/{getMaxDMsForAccount(account)})
    </MenuItem>
  );
})}
        </Select>
      </FormControl>
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button
      onClick={() => {
        setMarkDmedOpen(false);
        setMarkDmedLead(null);
        setMarkDmedAccount('Memphis 1');
      }}
      disabled={markDmedSaving}
    >
      Cancel
    </Button>

<Button
  variant="contained"
  onClick={handleConfirmMarkDmed}
  disabled={
    markDmedSaving ||
    !markDmedLead ||
    (manualDmCountsByAccount[markDmedAccount] || 0) >= getMaxDMsForAccount(markDmedAccount)
  }
  sx={{ borderRadius: 9999, textTransform: 'none', fontWeight: 700 }}
>
  {markDmedSaving ? 'Saving...' : 'Confirm'}
</Button>
  </DialogActions>
</Dialog>


        {valueModalPayload && (
          <Dialog
            open={valueModalOpen}
            onClose={handleCloseLeadValueModal}
            
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                borderRadius: 3,
                bgcolor: 'rgba(15,23,42,0.98)',
                border: '1px solid rgba(55,65,81,0.95)',
                boxShadow: '0 30px 80px rgba(0,0,0,0.9)',
                color: '#f9fafb',
                overflow: 'hidden',
              },
            }}
          >
            <DialogContent sx={{ p: 3 }}>
              {(() => {
                const { lead, dm, rawValue, jobSize, urgency, confidence, baseline } =
                  valueModalPayload;
                const svc = normalizeSvc(
                  lead.serviceType || lead.classification
                );
                const classification =
                  lead.aiGateVerdict || lead.verdict || 'good';

                const low = baseline.low;
                const high = baseline.high || baseline.low || rawValue;
                const avg = baseline.avg;
  const reasoning = getLeadValueReasoning(lead, dm);
                const span = Math.max(high - low, 1);
                const valuePercent = Math.min(
                  1,
                  Math.max(0, (rawValue - low) / span)
                );

                return (
                  <Box>
                    {/* Header */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 1.5,
                      }}
                    >
                      <Box>
                        <Typography
                          variant="overline"
                          sx={{
                            color: '#9ca3af',
                            letterSpacing: 1.5,
                            textTransform: 'uppercase',
                          }}
                        >
                          Lead value insight
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ color: '#f9fafb', fontWeight: 700 }}
                        >
                          {lead.author || 'Homeowner'} · {svc}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          gap: 0.5,
                        }}
                      >
                        <Chip
                          size="small"
                          label={`$${rawValue.toLocaleString()} est`}
                          sx={{
                            borderRadius: 9999,
                            bgcolor: 'rgba(22,163,74,0.18)',
                            border: '1px solid rgba(34,197,94,0.8)',
                            color: '#bbf7d0',
                            fontWeight: 700,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{ color: '#9ca3af' }}
                        >
                          AI classification:&nbsp;
                          <span style={{ color: '#22c55e' }}>
                            {String(classification).toUpperCase()}
                          </span>
                        </Typography>
                      </Box>
                    </Box>

                    {/* Chips row */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        mb: 2.5,
                      }}
                    >
                      <Chip
                        size="small"
                        label={svc}
                        sx={{
                          borderRadius: 9999,
                          bgcolor: 'rgba(15,23,42,1)',
                          border: '1px solid rgba(75,85,99,0.9)',
                          color: '#e5e7eb',
                        }}
                      />
                      {jobSize && (
                        <Chip
                          size="small"
                          label={`Job: ${jobSize}`}
                          sx={{
                            borderRadius: 9999,
                            bgcolor: 'rgba(15,23,42,1)',
                            border: '1px solid rgba(59,130,246,0.7)',
                            color: '#bfdbfe',
                          }}
                        />
                      )}
                      {urgency && (
                        <Chip
                          size="small"
                          label={`Urgency: ${urgency}`}
                          sx={{
                            borderRadius: 9999,
                            bgcolor: 'rgba(15,23,42,1)',
                            border: '1px solid rgba(234,179,8,0.8)',
                            color: '#facc15',
                          }}
                        />
                      )}
                      {confidence && (
                        <Chip
                          size="small"
                          label={`Confidence: ${confidence}`}
                          sx={{
                            borderRadius: 9999,
                            bgcolor: 'rgba(15,23,42,1)',
                            border: '1px solid rgba(34,197,94,0.7)',
                            color: '#bbf7d0',
                          }}
                        />
                      )}
                    </Box>

                    {/* Meter */}
                    <Box sx={{ mb: 2.5 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'baseline',
                          mb: 0.75,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: '#e5e7eb', fontWeight: 600 }}
                        >
                          Price band
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: '#9ca3af' }}
                        >
                          Low → High estimated ticket
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          position: 'relative',
                          height: 18,
                          borderRadius: 9999,
                          overflow: 'hidden',
                          background:
                            'linear-gradient(90deg, #ef4444, #eab308, #22c55e)',
                          boxShadow:
                            '0 0 30px rgba(34,197,94,0.3)',
                        }}
                      >
                        {/* Pointer */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: `${valuePercent * 100}%`,
                            transform: 'translate(-50%, -50%)',
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            bgcolor: '#f9fafb',
                            boxShadow:
                              '0 0 14px rgba(15,23,42,0.9)',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          mt: 0.75,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: '#f97316' }}
                        >
                          Low&nbsp;${low.toLocaleString()}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: '#eab308' }}
                        >
                          Avg&nbsp;${avg.toLocaleString()}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: '#22c55e' }}
                        >
                          High&nbsp;${high.toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Text summary */}
                    {/* AI reasoning summary */}
{reasoning && (
  <Box
    sx={{
      mt: 1,
      p: 1.25,
      borderRadius: 2,
      bgcolor: 'rgba(15,23,42,1)',
      border: '1px solid rgba(55,65,81,0.9)',
    }}
  >
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mb: 0.5,
        color: '#9ca3af',
      }}
    >
      Why AI priced this lead
    </Typography>
    <Typography
      variant="body2"
      sx={{
        whiteSpace: 'pre-line',
        color: '#e5e7eb',
      }}
    >
      {reasoning}
    </Typography>
  </Box>
)}

                    {/* Close button */}
                    <Box
                      sx={{
                        mt: 2.5,
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Button
                        onClick={handleCloseLeadValueModal}
                        variant="outlined"
                        size="small"
                        sx={{
                          textTransform: 'none',
                          borderRadius: 9999,
                          borderColor: 'rgba(148,163,184,0.6)',
                          color: '#f9fafb',
                          px: 2.5,
                          '&:hover': {
                            borderColor: '#22c55e',
                            background:
                              'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.12))',
                          },
                        }}
                      >
                        Close
                      </Button>
                    </Box>
                  </Box>
                );
              })()}
            </DialogContent>
          </Dialog>

          
        )}
      
    </Box>
    
        </Box>

  );
}